import { Group, Text, Button, Anchor, TextInput, Select, Grid, Table, Textarea, CopyButton, MultiSelect, Switch, ActionIcon, Flex, Checkbox, Pagination, Skeleton, Collapse, Divider, Modal, Alert, Box, Popover, Badge, Tooltip } from '@mantine/core';
import { IconHelp, IconCheck, IconPencil, IconTrash, IconX, IconPlus, IconCircleMinus, IconChevronDown, IconChevronUp, IconAlertTriangle, IconRefresh, IconCopy } from '@tabler/icons-react';
import { useState, useEffect, useRef } from 'react';
import { modals } from '@mantine/modals';
import '../EmailIntegration/EmailIntegration.css';
import { VisiLoader, useColorScheme, HelpTip } from "../../GeneralComponent/GeneralComponent";
import SettingsApi from "../../../api/SettingsApi";
import { useForm } from '@mantine/form';
import { useNavigate, useLocation } from "react-router-dom";
import { notifications } from '@mantine/notifications';
import { webhookSupportsTest, STRIPE_CHECKOUT_DOC_URL } from '../../GeneralComponent/webhookTestSteps';
import { WEBHOOK_INTEGRATION_FIELDS, REQUIRED_CREDENTIAL_PROCESSORS, AUTO_CREATE_PROCESSORS, CONVERSION_TYPE_PROCESSORS } from '../../GeneralComponent/webhookIntegrationFields';
import { VerifyWebhookModal } from './VerifyWebhookModal';

// Stripe checkout webhook setup documentation shown in the Generate Webhook Stripe block

// Webhook types that support Score & Rating Reporting - keys as used on this screen.
// Keep in step with the capture files that call extractWebhookNumericValue()
// (note ClickFunnels is 'clickfunnels' here but webhook_capture_clickfunnel.php).
const SCORE_RATING_PROCESSORS = ['custom', 'hubspot', 'gohighlevel', 'clickfunnels', 'katra', 'ontraport', 'kajabi', 'typeform', 'youform'];

// Display names for providers that support automatic webhook creation, used in post-save messages
const PROVIDER_DISPLAY_NAMES: Record<string, string> = {
  stripe: 'Stripe', authorize: 'Authorize.net', calendly: 'Calendly', chargebee: 'Chargebee',
  ontraport: 'Ontraport', kajabi: 'Kajabi', typeform: 'Typeform', woocommerce: 'WooCommerce',
  shopify: 'Shopify', hitpay: 'HitPay', youform: 'Youform', housecallpro: 'Housecall Pro',
  ultracart: 'UltraCart', clickfunnels: 'ClickFunnels', thrivecart: 'ThriveCart',
};

// Help popover for the Sale vs Opt-in Conversion Type dropdown. `note` overrides the last line.
function ConversionTypeHelp({ note }: { note?: string }) {
  return (
    <Popover width={330} position="right" withArrow shadow="md">
      <Popover.Target>
        <ActionIcon variant="light" color="blue" size="md" radius="sm" title="Conversion Type">
          <IconHelp size="1.1rem" />
        </ActionIcon>
      </Popover.Target>
      <Popover.Dropdown>
        <Text size="sm" fw={600} mb={6}>Conversion Type</Text>
        <Text size="xs" mb={4}>Choose what this webhook records in Visiopt:</Text>
        <Text size="xs" mb={4}><b>Sale (Purchase)</b> — a conversion with revenue, when a payment or order completes.</Text>
        <Text size="xs" mb={4}><b>Opt-in (Lead)</b> — a lead with no amount, when a new contact/customer is created (e.g. a form or account signup).</Text>
        <Text size="xs" color="dimmed">{note || 'If you enter credentials for automatic setup, this also decides which provider event Visiopt subscribes to.'}</Text>
      </Popover.Dropdown>
    </Popover>
  );
}

// Sale vs Opt-in dropdown row (label + select + help). `note` is passed through to the help popover.
function ConversionTypeField({ value, onChange, note }: { value: string; onChange: (ct: string) => void; note?: string }) {
  return (
    <Group spacing="sm" mb={14} align="center" noWrap>
      <Text size="sm" fz={14} fw={500} w={220} style={{ flexShrink: 0 }}>Conversion Type:</Text>
      <Select w={320} ml={0} size="sm" radius="sm"
        data={[
          { value: 'sale', label: 'Sale (Purchase)' },
          { value: 'optin', label: 'Opt-in (Lead)' },
        ]}
        value={value}
        onChange={(val: any) => onChange(val || 'sale')}
      />
      <ConversionTypeHelp note={note} />
    </Group>
  );
}

export function PaymentProcessingAndCarts({ SelectMemberWebsiteListValue }:any) {
	const [selectedMemberWebsite, setSelectedMemberWebsite] = useState('');
	const navigate = useNavigate();

  const [, setSubscription_show] = useState(false);
	const [activePPC, setActivePPC] = useState("payment-processing-carts");
	const [activeId, setActiveId] = useState(null);
	const [activePPCClass, setActivePPCClass] = useState([]);
	// "Verify Your Webhook" modal — opened after saving a webhook whose platform can fire a test event
	const [verifyModalOpen, setVerifyModalOpen] = useState(false);
	const [verifyWebhookId, setVerifyWebhookId] = useState('');
	const [verifyProcessor, setVerifyProcessor] = useState('');
	const [verifyWebhookUrl, setVerifyWebhookUrl] = useState('');
	const [verifyWebhookName, setVerifyWebhookName] = useState('');
	const customJSONText = '{ "transaction_id": "1111111", "sales_amount": "52.50", "transaction_type": "paid", "email": "test@gmail.com", "first_name": "test1", "last_name": "test2", "zipcode": "45321", "country": "US", "state": "LA", "city": "Gonzales", "_kx_vt": "1714736736", "_kx_sid": "1723236503d8d5b3c605c0ab69b26ed3adcfe3d8a4", "_n_sid_random": "1.1.10.1714736735", "ip_address": "12:15:15:18", "phone":"+14155552671" }';
	const customSampleJSCode = `
		<script type='text/javascript'>
	    function getVisiCookie3(name) {
	        var v = document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)');
	        return v ? v[2] : null;
	    }
	    var vtss_kx = setInterval(function(){
        if(typeof _kx_called != 'undefined' && _kx_called == true){
            var v_kx_vt = getVisiCookie3('_kx_vt');
            /*Here will get the variation no in JS variable v_kx_vt */
            console.log(v_kx_vt);
            var v_kx_sid = getVisiCookie3('_kx_sid');
            /*Here will get the variation no in JS variable v_kx_sid */
            console.log(v_kx_sid);
            var v_n_sid_random = getVisiCookie3('_n_sid_random');
            /*Here will get the variation no in JS variable v_n_sid_random */
            console.log(v_n_sid_random);
            clearInterval(vtss_kx);
        }
	    }, 50);
		</script>
	`;

  const [updateWebhookId, setUpdateWebhookId] = useState('');
  const itemsPerPage = 10;
  const [loading, setLoading] = useState(false);
  const [activePageAuthorize, setActivePageAuthorize] = useState(1);
  const [activePageHubSpot, setActivePageHubSpot] = useState(1);
  const [activePageChargebee, setActivePageChargebee] = useState(1);
  const [activePageStripe, setActivePageStripe] = useState(1);
  const [activePageCustomCart, setActivePageCustomCart] = useState(1);
  const [activePageWoocommerce, setActivePageWoocommerce] = useState(1);
  const [activePageThriveCart, setActivePageThriveCart] = useState(1);
  const [activePageEasypaydirect, setActivePageEasypaydirect] = useState(1);
  const [activePageHitpay, setActivePageHitpay] = useState(1);
  const [activePageHousecallpro, setActivePageHousecallpro] = useState(1);
  const [activePageMerchantx, setActivePageMerchantx] = useState(1);
  const [activePagePaypal, setActivePagePaypal] = useState(1);
  const [activePageGocardless, setActivePageGocardless] = useState(1);
  const [activePageRecurly, setActivePageRecurly] = useState(1);
  const [activePageCalendly, setActivePageCalendly] = useState(1);
  const [activePageBuygoods, setActivePageBuygoods] = useState(1);
  const [activePageClickbank, setActivePageClickbank] = useState(1);
  const [activePageClickfunnels, setActivePageClickfunnels] = useState(1);
  const [activePageGohighlevel, setActivePageGohighlevel] = useState(1);
  const [activePageDigistore24, setActivePageDigistore24] = useState(1);
  const [activePageKartra, setActivePageKartra] = useState(1);
  const [activePageKonnektive, setActivePageKonnektive] = useState(1);
  const [activePageKajabi, setActivePageKajabi] = useState(1);
  const [activePageOntraport, setActivePageOntraport] = useState(1);
  const [activePagePaykickstart, setActivePagePaykickstart] = useState(1);
  const [activePageSamcart, setActivePageSamcart] = useState(1);
  const [activePageStealthseminar, setActivePageStealthseminar] = useState(1);
  const [activePageShopify, setActivePageShopify] = useState(1);
  const [activePageUltracart, setActivePageUltracart] = useState(1);
  const [activePageTypeform, setActivePageTypeform] = useState(1);
  const [activePageYouform, setActivePageYouform] = useState(1);
  const colorTheme = useColorScheme();
  const editFormRef = useRef<HTMLDivElement>(null);
  /* Impact Summary "Review this webhook": open that webhook's processor, then its
     edit form, scrolled to "Count as Purchase" with the setting highlighted. */
  const location = useLocation();
  const webhookLinkRef = useRef<any>(location.state?.webhookKey ? {
    key: location.state.webhookKey,
    processor: location.state.webhookProcessor,
    action: location.state.webhookProcessor === 'authorize' ? 'autorize.net' : location.state.webhookProcessor === 'paypal' ? 'paypal_classic_ipn' : location.state.webhookProcessor,
  } : null);
  const [highlightWebhookId, setHighlightWebhookId] = useState('');
  const countAsPurchaseRef = useRef<HTMLDivElement>(null);
  const scrollToCountAsPurchaseRef = useRef(false);

	useEffect(() => {
    if(SelectMemberWebsiteListValue !== ""){
      setSelectedMemberWebsite(SelectMemberWebsiteListValue);
    }
  }, [SelectMemberWebsiteListValue]);

	const handleAction = (id:any) => {
		setActiveId(id);
		setHighlightWebhookId('');
		if(id === "cancel"){
      setUpdateWebhookId('');
			getPaymentProcessorsList();
			setActivePPC("payment-processing-carts");
      Object.values(forms).forEach((form) => form.reset());
      setWebhookRules([{ field: "", condition: "", value: "" }]);
      setSubscription_show(false);
      setDestinationWebhookIds([]);
      setCustomSchemaFields([]);
      savedDetectedJsonRef.current = '';
      setSchemaWarning('');
      setAdvancedOptionsOpen(false);
      setNumericValueEnabled(false);
      setNumericValueField('');
      setNumericValueMin('');
      setNumericValueMax('');
      setNumericValueLabel('');
      setClickfunnelsConversionType('sales');
      setConversionTypeSaleOptin('sale');
		}else {
			setActivePPC('');
		}
		if(id !== 'cancel'){
			let data_type = '';
			if(id === 'autorize.net'){
				data_type = 'authorize';
			}else if(id === 'paypal_classic_ipn'){
				data_type = 'paypal';
			}else{
				data_type = id;
			}
			setClickfunnelsConversionType('sales');
      setConversionTypeSaleOptin('sale');
			setReuseCredentialWebhookId('');
			getWebhookListData(data_type);
      getWebhookMappingData(data_type);
      getReusableCredentials(data_type);
		}
	};
  
	const getWebhookListData = (data_type:any) => {
		setPaymentProcessingCartLoader(true);
		SettingsApi.getwebhooklist({
      system_website_id: selectedMemberWebsite,
      data_type: data_type
    })
    .then(response => {
      if (response.ok) {
        return response.json();
      } else {
        if (response.status === 401 || response.status === 400) {
          setPaymentProcessingCartLoader(false);
          navigate("/logout");
        }
      }
    })
    .then(data => {
    	if(data.status === 1){
    		setWebhookListData(data.data.webhook_list_dropdown);
    		setWebhookUrlListData(data.data.webhook_table_data);
    		setPaymentProcessingCartLoader(false);
    	}else{
        setPaymentProcessingCartLoader(false);
        notifications.show({
          color: 'red',
          icon: <IconX size="1.1rem" />,
          title: 'Error',
          message: data.message,
        });
      }
    })
    .catch(error => {
      console.log(error);
      setPaymentProcessingCartLoader(false);
    });
	};

  // Fetch webhooks of this processor that already have a saved credential, to offer reuse
  const getReusableCredentials = (data_type:any, update_webhook_id:any = '') => {
    SettingsApi.getreusablecredentials({
      system_website_id: selectedMemberWebsite,
      webhook_processor: data_type,
      update_webhook_id: update_webhook_id
    })
    .then(response => (response && response.ok) ? response.json() : null)
    .then(data => {
      if (data && data.status === 1 && Array.isArray(data.data)) {
        setReusableCredentials(data.data);
      } else {
        setReusableCredentials([]);
      }
    })
    .catch(error => { console.log(error); setReusableCredentials([]); });
  };

  const getWebhookMappingData = (data_type:any, conversion_type:any = 'sales') => {
    setPaymentProcessingCartLoader(true);
    SettingsApi.getwebhookmappingdata({
      webhook_processor_name: data_type,
      conversion_type: conversion_type
    })
    .then(response => {
      if (response.ok) {
        return response.json();
      } else {
        if (response.status === 401 || response.status === 400) {
          setPaymentProcessingCartLoader(false);
          navigate("/logout");
        }
      }
    })
    .then(data => {
      if(data.status === 1){
        setWebhookMappingData(data.data.fields || data.data);
        setDefaultProcessorJson(data.data.raw_json || '');
        setPaymentProcessingCartLoader(false);
      }else{
        setPaymentProcessingCartLoader(false);
        notifications.show({
          color: 'red',
          icon: <IconX size="1.1rem" />,
          title: 'Error',
          message: data.message,
        });
      }
    })
    .catch(error => {
      console.log(error);
      setPaymentProcessingCartLoader(false);
    });
  };

  const paymentProcessorData = [
    { id: 1, action_name: 'autorize.net' ,img: 'img/cart-icons/authorize.png', name:'authorize.net' },
    { id: 2, action_name: 'chargebee' ,img: 'img/cart-icons/chargebee.png', name:'Chargebee' },
    { id: 3, action_name: 'easypaydirect' ,img: 'img/cart-icons/easypaydirect.png', name:'Easy Pay Direct' },
    { id: 6, action_name: 'gocardless' ,img: 'img/cart-icons/gocardless.png', name:'Go Cardless' },
    { id: 4, action_name: 'hitpay' ,img: 'img/cart-icons/hitpay.png', name:'Hit Pay' },
    { id: 5, action_name: 'housecallpro' ,img: 'img/cart-icons/housecallpro.png', name:'Housecall pro' },
    { id: 7, action_name: 'merchantx' ,img: 'img/cart-icons/merchantx.png', name:'Merchantx' },
    { id: 8, action_name: 'paypal_classic_ipn' ,img: 'img/cart-icons/paypal.png', name:'Paypal Classic IPN' },
    { id: 9, action_name: 'recurly' ,img: 'img/cart-icons/recurly.png', name:'Recurly' },
    { id: 10, action_name: 'stripe' ,img: 'img/cart-icons/stripe.png', name:'Stripe' },
  ];

  const shoppingCartsData = [
    { id: 1, action_name: 'buygoods' ,img: 'img/cart-icons/buygoods.png', name:'Buy Goods' },
    { id: 1, action_name: 'calendly' ,img: 'img/cart-icons/calendly.png', name:'Calendly' },
    { id: 2, action_name: 'clickbank' ,img: 'img/cart-icons/clickbank.png', name:'Click Bank' },
    { id: 3, action_name: 'clickfunnels' ,img: 'img/cart-icons/clickfunnels.png', name:'ClickFunnels' },
    { id: 3, action_name: 'digistore24' ,img: 'img/cart-icons/digistore24.png', name:'Digistore24' },
    { id: 4, action_name: 'gohighlevel' ,img: 'img/cart-icons/gohighlevel.png', name:'Go High Level' },
    { id: 17, action_name: 'hubspot' ,img: 'img/cart-icons/hubspot.png', name:'HubSpot' },
    { id: 5, action_name: 'kajabi' ,img: 'img/cart-icons/kajabi.png', name:'Kajabi' },
    { id: 6, action_name: 'katra' ,img: 'img/cart-icons/kartra.png', name:'Katra' },
    { id: 7, action_name: 'konnektive' ,img: 'img/cart-icons/konnektive.png', name:'Konnektive' },
    { id: 8, action_name: 'ontraport' ,img: 'img/cart-icons/ontraport.png', name:'Ontraport' },
    { id: 9, action_name: 'paykickstartes' ,img: 'img/cart-icons/paykickstart.png', name:'Paykickstart' },
    { id: 10, action_name: 'samcart' ,img: 'img/cart-icons/samcart.png', name:'Sam Cart' },
    { id: 11, action_name: 'shopify' ,img: 'img/cart-icons/shopify.png', name:'Shopify' },
    { id: 16, action_name: 'stealthseminar' ,img: 'img/cart-icons/stealthseminar.png', name:'Stealth Seminar' },
    { id: 13, action_name: 'thrivecart' ,img: 'img/cart-icons/thrivecart.png', name:'Thrive Cart' },
    { id: 18, action_name: 'typeform' ,img: 'img/cart-icons/typeform.png', name:'Typeform' },
    { id: 12, action_name: 'ultracart' ,img: 'img/cart-icons/ultracart.png', name:'UltraCart' },
    { id: 14, action_name: 'woocommerce' ,img: 'img/cart-icons/woocommerce.png', name:'Woocommerce' },
    { id: 19, action_name: 'youform' ,img: 'img/cart-icons/youform.png', name:'Youform' },
    { id: 15, action_name: 'custom' ,img: 'img/cart-icons/customcart.png', name:'Custom Cart' },
  ];

  const [PaymentProcessingCartLoader, setPaymentProcessingCartLoader] = useState(false);

  const forms = {
	  authorize_net: useForm({
	    initialValues: { webhook_name: '', selected_funnels: [], selected_webhook: '', selected_subscription_duration: '', unique_conversion: false, count_as_purchase: false, login_id: '', transaction_key: '', webhook_rule: false },
	  }),
	  chargebee: useForm({
	    initialValues: { webhook_name: '', selected_funnels: [], selected_webhook: '', selected_subscription_duration: '', unique_conversion: false, count_as_purchase: false, webhook_rule: false  },
	  }),
	  easypaydirect: useForm({
	    initialValues: { webhook_name: '', selected_funnels: [], selected_webhook: '', selected_subscription_duration: '', unique_conversion: false, count_as_purchase: false, webhook_rule: false  },
	  }),
	  hitpay: useForm({
	    initialValues: { webhook_name: '', selected_funnels: [], selected_webhook: '', selected_subscription_duration: '', unique_conversion: false, count_as_purchase: false, webhook_rule: false  },
	  }),
	  housecallpro: useForm({
	    initialValues: { webhook_name: '', selected_funnels: [], selected_webhook: '', selected_subscription_duration: '', unique_conversion: false, count_as_purchase: false, webhook_rule: false  },
	  }),
	  gocardless: useForm({
	    initialValues: { webhook_name: '', selected_funnels: [], selected_webhook: '', selected_subscription_duration: '', unique_conversion: false, count_as_purchase: false, access_token: '', account_type: 'LIVE', webhook_rule: false  },
	  }),
	  merchantx: useForm({
	    initialValues: { webhook_name: '', selected_funnels: [], selected_webhook: '', selected_subscription_duration: '', unique_conversion: false, count_as_purchase: false, access_token: '', account_type: 'LIVE', webhook_rule: false  },
	  }),
	  paypal: useForm({
	    initialValues: { webhook_name: '', selected_funnels: [], selected_webhook: '', selected_subscription_duration: '', unique_conversion: false, count_as_purchase: false, access_token: '', account_type: 'LIVE', webhook_rule: false  },
	  }),
	  recurly: useForm({
	    initialValues: { webhook_name: '', selected_funnels: [], selected_webhook: '', selected_subscription_duration: '', unique_conversion: false, count_as_purchase: false, access_token: '', account_type: 'LIVE', webhook_rule: false  },
	  }),
	  stripe: useForm({
	    initialValues: { webhook_name: '', selected_funnels: [], selected_webhook: '', selected_subscription_duration: '', unique_conversion: false, count_as_purchase: false, secret_key: '', webhook_rule: false  },
	  }),	 
    buygoods: useForm({
      initialValues: { webhook_name: '', selected_funnels: [], selected_webhook: '', selected_subscription_duration: '', unique_conversion: false, count_as_purchase: false, webhook_rule: false  },
    }), 
    calendly: useForm({
      initialValues: { webhook_name: '', selected_funnels: [], selected_webhook: '', selected_subscription_duration: '', unique_conversion: false, count_as_purchase: false, webhook_rule: false  },
    }),
    clickfunnels: useForm({
      initialValues: { webhook_name: '', selected_funnels: [], selected_webhook: '', selected_subscription_duration: '', unique_conversion: false, count_as_purchase: false, webhook_rule: false  },
    }),
    clickbank: useForm({
      initialValues: { webhook_name: '', selected_funnels: [], selected_webhook: '', selected_subscription_duration: '', unique_conversion: false, count_as_purchase: false, secret_key: '', webhook_rule: false  },
    }),
    digistore24: useForm({
      initialValues: { webhook_name: '', selected_funnels: [], selected_webhook: '', selected_subscription_duration: '', unique_conversion: false, count_as_purchase: false, webhook_rule: false  },
    }),
    gohighlevel: useForm({
      initialValues: { webhook_name: '', selected_funnels: [], selected_webhook: '', selected_subscription_duration: '', unique_conversion: false, count_as_purchase: false, webhook_rule: false  },
    }),
    kajabi: useForm({
      initialValues: { webhook_name: '', selected_funnels: [], selected_webhook: '', selected_subscription_duration: '', unique_conversion: false, count_as_purchase: false, webhook_rule: false  },
    }),
    katra: useForm({
      initialValues: { webhook_name: '', selected_funnels: [], selected_webhook: '', selected_subscription_duration: '', unique_conversion: false, count_as_purchase: false, webhook_rule: false  },
    }),
    konnektive: useForm({
      initialValues: { webhook_name: '', selected_funnels: [], selected_webhook: '', selected_subscription_duration: '', unique_conversion: false, count_as_purchase: false, webhook_rule: false  },
    }),
    ontraport: useForm({
      initialValues: { webhook_name: '', selected_funnels: [], selected_webhook: '', selected_subscription_duration: '', unique_conversion: false, count_as_purchase: false, webhook_rule: false  },
    }),
    paykickstartes: useForm({
      initialValues: { webhook_name: '', selected_funnels: [], selected_webhook: '', selected_subscription_duration: '', unique_conversion: false, count_as_purchase: false, webhook_rule: false  },
    }),
    samcart: useForm({
      initialValues: { webhook_name: '', selected_funnels: [], selected_webhook: '', selected_subscription_duration: '', unique_conversion: false, count_as_purchase: false, webhook_rule: false  },
    }),
    shopify: useForm({
      initialValues: { webhook_name: '', selected_funnels: [], selected_webhook: '', selected_subscription_duration: '', unique_conversion: false, count_as_purchase: false, webhook_rule: false  },
    }),
    stealthseminar: useForm({
      initialValues: { webhook_name: '', selected_funnels: [], selected_webhook: '', selected_subscription_duration: '', unique_conversion: false, count_as_purchase: false, webhook_rule: false  },
    }),
    ultracart: useForm({
      initialValues: { webhook_name: '', selected_funnels: [], selected_webhook: '', selected_subscription_duration: '', unique_conversion: false, count_as_purchase: false, webhook_rule: false  },
    }),
    thrivecart: useForm({
      initialValues: { webhook_name: '', selected_funnels: [], selected_webhook: '', selected_subscription_duration: '', unique_conversion: false, count_as_purchase: false, webhook_rule: false  },
    }),
    woocommerce: useForm({
      initialValues: { webhook_name: '', selected_funnels: [], selected_webhook: '', selected_subscription_duration: '', unique_conversion: false, count_as_purchase: false, webhook_rule: false  },
    }),
    custom: useForm({
      initialValues: { webhook_name: '', selected_funnels: [], selected_webhook: '', selected_subscription_duration: '', unique_conversion: false, count_as_purchase: false, webhook_rule: false  },
    }),
    hubspot: useForm({
      initialValues: { webhook_name: '', selected_funnels: [], selected_webhook: '', selected_subscription_duration: '', hubspot_access_token: '', hubspot_redirect_url: '', unique_conversion: false, count_as_purchase: false, webhook_rule: false  },
    }),
    typeform: useForm({
      initialValues: { webhook_name: '', selected_funnels: [], selected_webhook: '', selected_subscription_duration: '', unique_conversion: false, count_as_purchase: false, webhook_rule: false  },
    }),
    youform: useForm({
      initialValues: { webhook_name: '', selected_funnels: [], selected_webhook: '', selected_subscription_duration: '', unique_conversion: false, count_as_purchase: false, webhook_rule: false  },
    }),
	};

  const handleSaveWebhook = (formData:any, processor:any, slug:any, form:any) => {
    // Skip credential validation when reusing an existing webhook's saved credentials
    const isReusingCredentials = reuseCredentialWebhookId !== '';
    // Stripe credentials are optional (used only to auto-create the webhook), only validate the format when a key is entered
    if (processor === 'stripe' && !isReusingCredentials) {
      const stripeSecretKey = (formData.secret_key || '').trim();
      if (stripeSecretKey !== '' && stripeSecretKey.indexOf('*') === -1 && stripeSecretKey.indexOf('sk_') !== 0) {
        notifications.show({ color: 'red', icon: <IconX size="1.1rem" />, title: 'Error', message: 'Invalid Stripe Secret Key. It must start with sk_.' });
        setAdvancedOptionsOpen(true);
        return;
      }
    }
    if (processor === 'authorize' && !isReusingCredentials) {
      if ((formData.login_id || '').trim() === '' || (formData.transaction_key || '').trim() === '') {
        notifications.show({ color: 'red', icon: <IconX size="1.1rem" />, title: 'Error', message: 'Please enter the Authorize.net Login ID and Transaction Key.' });
        setAdvancedOptionsOpen(true);
        return;
      }
    }

    if (formData.webhook_rule === true) {
      for (let i = 0; i < webhookRules.length; i++) {
        const { field, condition, value } = webhookRules[i];

        if (!field) {
          notifications.show({
            color: 'red',
            icon: <IconX size="1.1rem" />,
            title: 'Error',
            message: `Rule ${i + 1}: Please select a field.`,
          });
          return;
        }

        if (!condition) {
          notifications.show({
            color: 'red',
            icon: <IconX size="1.1rem" />,
            title: 'Error',
            message: `Rule ${i + 1}: Please select a condition.`,
          });
          return;
        }

        if (!value) {
          notifications.show({
            color: 'red',
            icon: <IconX size="1.1rem" />,
            title: 'Error',
            message: `Rule ${i + 1}: Please enter a value.`,
          });
          return;
        }
      }
    }
    
    const formattedRules = webhookRules.map(r => ({
      field: r.field,
      condition: r.condition,
      value: r.value,
    }));

    // Loop protection: prevent destination webhooks from including itself
    if (destinationWebhookIds.length > 0 && updateWebhookId && destinationWebhookIds.includes(updateWebhookId)) {
      notifications.show({ color: 'red', icon: <IconX size="1.1rem" />, title: 'Error', message: 'Destination webhooks cannot include the current webhook. Please remove it.' });
      return;
    }

    /* Only HubSpot has a default field, so on any other webhook type saving with
       this blank would leave the feature switched on and silently doing nothing. */
    if (processor !== 'hubspot' && numericValueEnabled && numericValueField.trim() === '') {
      notifications.show({ color: 'red', icon: <IconX size="1.1rem" />, title: 'Error', message: 'Please enter the Value Field for Score & Rating Reporting.' });
      return;
    }

    // Prevent saving if schema warning exists (invalid rule references)
    if (schemaWarning && formData.webhook_rule) {
      notifications.show({ color: 'red', icon: <IconX size="1.1rem" />, title: 'Error', message: 'Please fix invalid rule references before saving.' });
      return;
    }

    const dataObject = {
    	system_website_id: selectedMemberWebsite,
    	webhook_name: formData.webhook_name !== "" ? JSON.stringify(formData.webhook_name) : '',
    	webhook_processor: processor,
    	funnel_id: formData.selected_funnels,
    	link_webhook_id: formData.selected_webhook,
      subscription_show: formData.subscription_show === true ? 1 : 0,
      subscription_duration: formData.selected_subscription_duration,
    	sales_conversion_webhook: formData.unique_conversion === true ? 1 : 0,
    	count_as_purchase: formData.count_as_purchase === true ? 1 : 0,
      webhook_rule_show: formData.webhook_rule === true ? 1 : 0,
      mappings_data: formattedRules,
    	account_type: 'SANDBOX',
    	webhook_slug:  slug,
      destination_webhook_ids: destinationWebhookIds.length > 0 ? destinationWebhookIds : [],
      custom_schema: customSchemaFields.length > 0 ? JSON.stringify({ fields: customSchemaFields, raw_json: savedDetectedJsonRef.current }) : '',
      numeric_value_enabled: numericValueEnabled ? 1 : 0,
      numeric_value_field: numericValueField,
      numeric_value_aggregation: 'average',
      numeric_value_min: numericValueMin,
      numeric_value_max: numericValueMax,
      numeric_value_label: numericValueLabel
    } as any;
    if(processor === 'authorize'){
    	dataObject.login_id = formData.login_id;
    	dataObject.transaction_key = formData.transaction_key;
    }
    // Optional auto-create credentials, sent as-is and skipped server side when blank
    if(['calendly','chargebee','ontraport','kajabi','typeform','woocommerce','shopify','hitpay','youform','housecallpro','ultracart','clickfunnels','thrivecart'].includes(processor)){
      dataObject.login_id = formData.login_id || '';
      dataObject.transaction_key = formData.transaction_key || '';
      dataObject.access_token = formData.access_token || '';
      dataObject.secret_key = formData.secret_key || '';
    }
    if(processor === 'gocardless'){
    	dataObject.access_token = formData.access_token;
    	dataObject.account_type = formData.account_type;
    }
    if(processor === 'clickfunnels'){
      dataObject.clickfunnels_conversion_type = clickfunnelsConversionType;
    }
    if(CONVERSION_TYPE_PROCESSORS.includes(processor)){
      dataObject.conversion_type = conversionTypeSaleOptin;
    }
    // Reuse the credentials saved on another webhook of this processor instead of the entered ones
    if(reuseCredentialWebhookId !== ''){
      dataObject.reuse_credential_from_webhook_id = reuseCredentialWebhookId;
    }
    if(processor === 'stripe'){
    	dataObject.secret_key = formData.secret_key;
    }
    if(processor === 'clickbank'){
      dataObject.secret_key = formData.secret_key;
    }
    if(processor === 'hubspot'){
      dataObject.hubspot_access_token = formData.hubspot_access_token;
    }
    if(updateWebhookId !== ''){
    	dataObject.update_webhook_id = updateWebhookId;
    }
    // Captured now: the success handler clears updateWebhookId before it runs
    const isEditingWebhook = updateWebhookId !== '';
    setPaymentProcessingCartLoader(true);
  	SettingsApi.insertwebhooks(dataObject)
    .then(response => {
      if (response.ok) {
        return response.json();
      } else {
        if (response.status === 401 || response.status === 400) {
          setPaymentProcessingCartLoader(false);
          navigate("/logout");
        }
      }
    })
    .then(data => {
    	if(data.status === 1){
    		setPaymentProcessingCartLoader(false);
    		notifications.show({
          color: 'green',
          icon: <IconCheck size="1.1rem" />,
          title: 'Success',
          message: data.message,
        });
        // Auto-create messaging only fires when the backend actually attempted creation (credentials/connected store present)
        const autoCreateAttempted = (data.data && data.data.auto_create_attempted) ? true : false;
        const isShopify = processor === 'shopify';
        if (autoCreateAttempted) {
          const providerName = PROVIDER_DISPLAY_NAMES[processor] || processor;
          const providerWarning = (data.data && data.data.stripe_warning) ? data.data.stripe_warning : '';
          setStripeSaveNotice({ warning: providerWarning, providerName: providerName });
          if (providerWarning) {
            notifications.show({
              color: 'red',
              icon: <IconX size="1.1rem" />,
              title: providerName + ' webhook not created',
              message: isShopify
                ? 'We were unable to create the Shopify webhook automatically. Please create the webhook manually in your Shopify store using the webhook URL shown in the list below.'
                : 'The ' + providerName + ' webhook could not be created automatically: ' + providerWarning + ' Your VisiOpt configuration was still saved. You can correct the credentials and save again, or create the webhook manually in your ' + providerName + ' account using the webhook URL shown in the list below.',
              autoClose: false,
            });
          } else if (isShopify) {
            notifications.show({
              color: 'green',
              icon: <IconCheck size="1.1rem" />,
              title: 'Shopify webhook created successfully',
              message: 'Shopify webhook has been created successfully. No further action is required. Please do not create the webhook manually in your Shopify store.',
              autoClose: 12000,
            });
          } else {
            notifications.show({
              color: 'blue',
              icon: <IconAlertTriangle size="1.1rem" />,
              title: 'Verify your ' + providerName + ' webhook',
              message: 'Your configuration has been saved successfully. If no error is shown here, please log in to your ' + providerName + ' account and verify that the VisiOpt webhook has been created. If you do not see the webhook, please create it manually using the webhook URL provided by VisiOpt.',
              autoClose: 12000,
            });
          }
        } else {
          setStripeSaveNotice(null);
        }
        setUpdateWebhookId('');
    		Object.values(forms).forEach((form) => form.reset());
        setWebhookRules([{ field: "", condition: "", value: "" }]);
        setDestinationWebhookIds([]);
        setCustomSchemaFields([]);
        savedDetectedJsonRef.current = '';
        setSchemaWarning('');
        setAdvancedOptionsOpen(false);
        setClickfunnelsConversionType('sales');
        setConversionTypeSaleOptin('sale');
        setReuseCredentialWebhookId('');
    		getWebhookListData(processor);
        getReusableCredentials(processor);
        if (!isEditingWebhook && webhookSupportsTest(processor) && data.data && data.data.webhook_id) {
          setVerifyWebhookId(data.data.webhook_id);
          setVerifyProcessor(processor);
          setVerifyWebhookUrl(data.data.webhook_url || '');
          setVerifyWebhookName(formData.webhook_name || '');
          setVerifyModalOpen(true);
        }
    	}else{
    		setPaymentProcessingCartLoader(false);
        notifications.show({
          color: 'red',
          icon: <IconX size="1.1rem" />,
          title: 'Error',
          message: data.message,
        });
        setAdvancedOptionsOpen(true);
    	}
    })
    .catch(error => {
      console.log(error);
      setPaymentProcessingCartLoader(false);
    });
	};

	const getPaymentProcessorsList = () => {
		setPaymentProcessingCartLoader(true);
		SettingsApi.getpaymentprocessorscartlist({
      system_website_id: selectedMemberWebsite
    })
    .then(response => {
      if (response.ok) {
        return response.json();
      } else {
        if (response.status === 401 || response.status === 400) {
          setPaymentProcessingCartLoader(false);
          navigate("/logout");
        }
      }
    })
    .then(data => {
      if(data.status === 1 && data.data){
      	let activeIntegrations = [];
      	if(data.data.payment_processor_and_cart_list["authorize"] && data.data.payment_processor_and_cart_list["authorize"] === 'connected'){
      		activeIntegrations.push('autorize.net');
      	}
      	if(data.data.payment_processor_and_cart_list["chargebee"] && data.data.payment_processor_and_cart_list["chargebee"] === 'connected'){
      		activeIntegrations.push('chargebee');      		
      	}
      	if(data.data.payment_processor_and_cart_list["easypaydirect"] && data.data.payment_processor_and_cart_list["easypaydirect"] === 'connected'){
      		activeIntegrations.push('easypaydirect');      		
      	}
      	if(data.data.payment_processor_and_cart_list["hitpay"] && data.data.payment_processor_and_cart_list["hitpay"] === 'connected'){
      		activeIntegrations.push('hitpay');      		
      	}
      	if(data.data.payment_processor_and_cart_list["housecallpro"] && data.data.payment_processor_and_cart_list["housecallpro"] === 'connected'){
      		activeIntegrations.push('housecallpro');      		
      	}
      	if(data.data.payment_processor_and_cart_list["gocardless"] && data.data.payment_processor_and_cart_list["gocardless"] === 'connected'){
      		activeIntegrations.push('gocardless');
      	}
      	if(data.data.payment_processor_and_cart_list["merchantx"] && data.data.payment_processor_and_cart_list["merchantx"] === 'connected'){
      		activeIntegrations.push('merchantx');      		
      	}
      	if(data.data.payment_processor_and_cart_list["paypal"] && data.data.payment_processor_and_cart_list["paypal"] === 'connected'){
      		activeIntegrations.push('paypal_classic_ipn');      		
      	}
      	if(data.data.payment_processor_and_cart_list["recurly"] && data.data.payment_processor_and_cart_list["recurly"] === 'connected'){
      		activeIntegrations.push('recurly');      		
      	}
      	if(data.data.payment_processor_and_cart_list["stripe"] && data.data.payment_processor_and_cart_list["stripe"] === 'connected'){ 
      		activeIntegrations.push('stripe');      		     		
      	}
      	if(data.data.payment_processor_and_cart_list["buygoods"] && data.data.payment_processor_and_cart_list["buygoods"] === 'connected'){
      		activeIntegrations.push('buygoods');      		
      	}
      	if(data.data.payment_processor_and_cart_list["calendly"] && data.data.payment_processor_and_cart_list["calendly"] === 'connected'){
      		activeIntegrations.push('calendly');      		
      	}
      	if(data.data.payment_processor_and_cart_list["clickbank"] && data.data.payment_processor_and_cart_list["clickbank"] === 'connected'){
      		activeIntegrations.push('clickbank');      		
      	}
      	if(data.data.payment_processor_and_cart_list["clickfunnels"] && data.data.payment_processor_and_cart_list["clickfunnels"] === 'connected'){
      		activeIntegrations.push('clickfunnels');      		
      	}
      	if(data.data.payment_processor_and_cart_list["digistore24"] && data.data.payment_processor_and_cart_list["digistore24"] === 'connected'){
      		activeIntegrations.push('digistore24');      		
      	}
      	if(data.data.payment_processor_and_cart_list["gohighlevel"] && data.data.payment_processor_and_cart_list["gohighlevel"] === 'connected'){
      		activeIntegrations.push('gohighlevel');      		
      	}
      	if(data.data.payment_processor_and_cart_list["kajabi"] && data.data.payment_processor_and_cart_list["kajabi"] === 'connected'){
      		activeIntegrations.push('kajabi');      		
      	}
      	if(data.data.payment_processor_and_cart_list["katra"] && data.data.payment_processor_and_cart_list["katra"] === 'connected'){
      		activeIntegrations.push('katra');      		
      	}
      	if(data.data.payment_processor_and_cart_list["konnektive"] && data.data.payment_processor_and_cart_list["konnektive"] === 'connected'){
      		activeIntegrations.push('konnektive');      		
      	}
      	if(data.data.payment_processor_and_cart_list["ontraport"] && data.data.payment_processor_and_cart_list["ontraport"] === 'connected'){
      		activeIntegrations.push('ontraport');      		
      	}
      	if(data.data.payment_processor_and_cart_list["paykickstartes"] && data.data.payment_processor_and_cart_list["paykickstartes"] === 'connected'){
      		activeIntegrations.push('paykickstartes');      		
      	}
      	if(data.data.payment_processor_and_cart_list["samcart"] && data.data.payment_processor_and_cart_list["samcart"] === 'connected'){
      		activeIntegrations.push('samcart');      	
      	}
        if(data.data.payment_processor_and_cart_list["stealthseminar"] && data.data.payment_processor_and_cart_list["stealthseminar"] === 'connected'){
          activeIntegrations.push('stealthseminar');        
        }
      	if(data.data.payment_processor_and_cart_list["shopify"] && data.data.payment_processor_and_cart_list["shopify"] === 'connected'){
      		activeIntegrations.push('shopify');      		
      	}
      	if(data.data.payment_processor_and_cart_list["ultracart"] && data.data.payment_processor_and_cart_list["ultracart"] === 'connected'){
      		activeIntegrations.push('ultracart');      	
      	}
      	if(data.data.payment_processor_and_cart_list["thrivecart"] && data.data.payment_processor_and_cart_list["thrivecart"] === 'connected'){
      		activeIntegrations.push('thrivecart');      		
      	}
      	if(data.data.payment_processor_and_cart_list["woocommerce"] && data.data.payment_processor_and_cart_list["woocommerce"] === 'connected'){
      		activeIntegrations.push('woocommerce');      		
      	}
      	if(data.data.payment_processor_and_cart_list["custom"] && data.data.payment_processor_and_cart_list["custom"] === 'connected'){
      		activeIntegrations.push('custom');      		
      	}
        if(data.data.payment_processor_and_cart_list["hubspot"] && data.data.payment_processor_and_cart_list["hubspot"] === 'connected'){
          activeIntegrations.push('hubspot');
        }
        if(data.data.payment_processor_and_cart_list["typeform"] && data.data.payment_processor_and_cart_list["typeform"] === 'connected'){
          activeIntegrations.push('typeform');
        }
        if(data.data.payment_processor_and_cart_list["youform"] && data.data.payment_processor_and_cart_list["youform"] === 'connected'){
          activeIntegrations.push('youform');
        }
      	setActivePPCClass(activeIntegrations);
        setPaymentProcessingCartLoader(false);
      }else{
        notifications.show({
          color: 'red',
          icon: <IconX size="1.1rem" />,
          title: 'Error',
          message: data.message,
        });
        setPaymentProcessingCartLoader(false);
      }
    })
    .catch(error => {
      console.log(error);
      setPaymentProcessingCartLoader(false);
    });
	};

	useEffect(() => {
    if(selectedMemberWebsite !== ''){
  		getPaymentProcessorsList();
      setActiveId(null);
      setActivePPC("payment-processing-carts");
  		SettingsApi.getsettingfunnellist({
        system_website_id: selectedMemberWebsite
      })
      .then(response => {
        if (response.ok) {
          return response.json();
        } else {
          if (response.status === 401 || response.status === 400) {
            setPaymentProcessingCartLoader(false);
            navigate("/logout");
          }
        }
      })
      .then(data => {
        if(data.status === 1 && data.data){
        	setFunnelListData(data.data);
          setPaymentProcessingCartLoader(false);
        }else{
          setPaymentProcessingCartLoader(false);
          notifications.show({
            color: 'red',
            icon: <IconX size="1.1rem" />,
            title: 'Error',
            message: data.message,
          });
        }
      })
      .catch(error => {
        console.log(error);
        setPaymentProcessingCartLoader(false);
      });
    }
	}, [selectedMemberWebsite]);


  const [funnelListData, setFunnelListData] = useState([]);
  const [webhookListData, setWebhookListData] = useState([]);
  const [webhookUrlListData, setWebhookUrlListData] = useState([]);
  const [webhookMappingData, setWebhookMappingData] = useState([]);

  // Impact Summary link, step 1: once the website is known, open the webhook's processor.
  useEffect(() => {
    const link = webhookLinkRef.current;
    if (selectedMemberWebsite === '' || !link || link.listRequested) {
      return;
    }
    if ([...paymentProcessorData, ...shoppingCartsData].some((item) => item.action_name === link.action)) {
      link.listRequested = true;
      handleAction(link.action);
    } else {
      webhookLinkRef.current = null;
    }
  }, [selectedMemberWebsite]);

  // Step 2: when that processor's list arrives, edit the webhook - only if it is on this website.
  useEffect(() => {
    const link = webhookLinkRef.current;
    if (!link || !link.listRequested || activeId !== link.action) {
      return;
    }
    webhookLinkRef.current = null;
    if (Object.values(webhookUrlListData || {}).some((row: any) => row && row.webhook_id === link.key)) {
      handleEditWebhook(link.key, link.processor);
      setHighlightWebhookId(link.key);
      scrollToCountAsPurchaseRef.current = true;
    }
  }, [webhookUrlListData]);

  // Step 3: once the form has loaded, scroll to "Count as Purchase" (once).
  useEffect(() => {
    if (scrollToCountAsPurchaseRef.current && !PaymentProcessingCartLoader && highlightWebhookId !== '' && highlightWebhookId === updateWebhookId) {
      scrollToCountAsPurchaseRef.current = false;
      countAsPurchaseRef.current?.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }, [PaymentProcessingCartLoader, highlightWebhookId]);

	// Re-check a single webhook's verification status on demand, so we don't poll the
	// whole list. Only the clicked row is refreshed.
	const [refreshingWebhookId, setRefreshingWebhookId] = useState('');

	const refreshVerificationStatus = (webhookId: string) => {
		setRefreshingWebhookId(webhookId);
		SettingsApi.getwebhookverificationstatus({ webhook_id: webhookId })
			.then((r:any) => (r.ok ? r.json() : null))
			.then((data:any) => {
				setRefreshingWebhookId('');
				if (!data || data.status !== 1 || !data.data) {
					notifications.show({ color: 'red', icon: <IconX size="1.1rem" />, title: 'Error', message: (data && data.message) || 'Could not refresh the verification status.' });
					return;
				}
				const verified = Number(data.data.verification_status) === 1;
				setWebhookUrlListData((prev:any) =>
					Object.fromEntries(
						Object.entries(prev || {}).map(([k, row]:any) =>
							row && row.webhook_id === webhookId ? [k, { ...row, verification_status: verified ? 1 : 0 }] : [k, row]
						)
					) as any
				);
				if (!verified) {
					notifications.show({ color: 'yellow', icon: <IconAlertTriangle size="1.1rem" />, title: 'Still waiting', message: 'No event received yet for this webhook.' });
				}
			})
			.catch(() => {
				setRefreshingWebhookId('');
				notifications.show({ color: 'red', icon: <IconX size="1.1rem" />, title: 'Error', message: 'Could not refresh the verification status.' });
			});
	};

  const selectWebhookMappingData = [
    { value: '', label: 'Select Field', disabled: true },
    ...Object.entries(webhookMappingData).map(([index, item]) => ({
      value: item.key,
      label: item.value,
    })),
  ];

	const multiSelectFunnelData = [
    { value: '', label: 'Select Funnel', disabled: true },
    ...funnelListData.map((item) => ({
      value: item.funnel_id,
      label: item.funnel_name,
    })),
  ];

  const selectWebhookListData = [
    { value: '', label: 'Select Webhook', disabled: false },
    ...Object.entries(webhookListData).map(([index, item]) => ({
      value: item.webhook_id,
      label: item.webhook_name,
    })),
  ];

  const selectSubscriptionDurationListData = [
    { value: '', label: 'Select a Recurring Duration', disabled: true },
    { value: '7', label: '7 Days' },
    { value: '15', label: '15 Days' },
    { value: '30', label: '30 Days' },
    { value: '90', label: '3 Months' },
    { value: '180', label: '6 Months' },
  ];

	const deleteCustomWebhookDelete = (webhookId:any, processor:any) => modals.openConfirmModal({
    trapFocus: false,
    title: 'Please confirm your action',
    children: (
      <Text size="sm">
        Are you sure you want to delete this Webhook?
      </Text>
    ),
    labels: { confirm: 'Confirm', cancel: 'Cancel' },
    onCancel: () => console.log('Cancel'),
    onConfirm: () => handleDeleteWebhook(webhookId, processor),
  });

  const handleDeleteWebhook = (webhookId:any, processor:any) => {
  	setPaymentProcessingCartLoader(true);
    SettingsApi.deletewebhook({
      webhook_id: webhookId
    })
    .then(response => {
      if (response.ok) {
        return response.json();
      } else {
        if (response.status === 401 || response.status === 400) {
          setPaymentProcessingCartLoader(false);
          navigate("/logout");
        }
      }
    })
    .then(data => {
    	if(data.status === 1){
    		notifications.show({
          color: 'green',
          icon: <IconCheck size="1.1rem" />,
          title: 'Success',
          message: data.message,
        });
        setPaymentProcessingCartLoader(true);
    		getWebhookListData(processor);
        getReusableCredentials(processor);
        setWebhookRules([{ field: "", condition: "", value: "" }]);
    	}else{
        setPaymentProcessingCartLoader(false);
        notifications.show({
          color: 'red',
          icon: <IconX size="1.1rem" />,
          title: 'Error',
          message: data.message,
        });
      }
    })
    .catch(error => {
      console.log(error);
      setPaymentProcessingCartLoader(false);
    });
  };

  const handleEditWebhook = (webhookId:any, processor:any) => {
    editFormRef.current?.scrollIntoView({ behavior: "smooth" });
  	setUpdateWebhookId(webhookId);
    // Show the saved (masked) credentials on edit, and refresh the reuse list excluding this webhook
    setReuseCredentialWebhookId('');
    getReusableCredentials(processor, webhookId);
  	let processor_form = [] as any;
    if(processor === 'authorize'){
      processor_form = forms['authorize_net'];
    }else{
      processor_form = forms[processor];
    }
  	setPaymentProcessingCartLoader(true);
    SettingsApi.getsinglewebhookdetail({
    	webhook_id: webhookId
    })
    .then(response => {
      if (response.ok) {
        return response.json();
      } else {
        if (response.status === 401 || response.status === 400) {
          setPaymentProcessingCartLoader(false);
          navigate("/logout");
        }
      }
    })
    .then(data => {
      if(data.status === 1 && data.data){
      	processor_form.setFieldValue('webhook_name', data.data.webhook_name);
      	processor_form.setFieldValue('selected_funnels', data.data.funnel_id);
      	processor_form.setFieldValue('selected_webhook', data.data.link_webhook_id);
      	processor_form.setFieldValue('unique_conversion', data.data.sales_conversion);
      	processor_form.setFieldValue('count_as_purchase', data.data.count_as_purchase === true);
        processor_form.setFieldValue('subscription_show', data.data.subscription_show);
        processor_form.setFieldValue('webhook_rule', !!data.data.webhook_rule_show);
        if (data.data.webhook_rule_show) {
          setWebhookRules(data.data.webhook_rules.length ? data.data.webhook_rules : [{ field: "", condition: "", value: "" }]);
        } else {
          setWebhookRules([{ field: "", condition: "", value: "" }]);
        }
        processor_form.setFieldValue('selected_subscription_duration', data.data.selected_subscription_duration);
        const savedRules = Array.isArray(data.data.webhook_rules) ? data.data.webhook_rules : [];
        const editConversionType = savedRules.some((r:any) => typeof r.field === 'string' && r.field.indexOf('contact') === 0) ? 'optin' : 'sales';
        setClickfunnelsConversionType(editConversionType);
        if (processor === 'clickfunnels') {
          getWebhookMappingData('clickfunnels', editConversionType);
        }
        setNumericValueEnabled(data.data.numeric_value_enabled === true);
        setNumericValueField(data.data.numeric_value_field || '');
        setNumericValueMin(data.data.numeric_value_min === '' || data.data.numeric_value_min === null || data.data.numeric_value_min === undefined ? '' : String(data.data.numeric_value_min));
        setNumericValueMax(data.data.numeric_value_max === '' || data.data.numeric_value_max === null || data.data.numeric_value_max === undefined ? '' : String(data.data.numeric_value_max));
        setNumericValueLabel(data.data.numeric_value_label ?? '');
        if (data.data.numeric_value_enabled === true) {
          setAdvancedOptionsOpen(true);
        }
        if (CONVERSION_TYPE_PROCESSORS.includes(processor)) {
          const savedConvType = data.data.conversion_type === 'optin' ? 'optin' : 'sale';
          setConversionTypeSaleOptin(savedConvType);
          getWebhookMappingData(processor, savedConvType);
        }
      	if(processor === 'authorize'){
      		forms.authorize_net.setFieldValue('login_id', data.data.login_id);
      		forms.authorize_net.setFieldValue('transaction_key', data.data.transaction_key);
      	}
      	if(processor === 'gocardless'){
      		forms.gocardless.setFieldValue('access_token', data.data.access_token);
      		forms.gocardless.setFieldValue('account_type', data.data.account_type);
      	}
      	if(processor === 'stripe'){
      		forms.stripe.setFieldValue('secret_key', data.data.secret_key);
      	}
        if(processor === 'clickbank'){
          forms.clickbank.setFieldValue('secret_key', data.data.secret_key);
        }
        if(processor === 'hubspot'){
          forms.hubspot.setFieldValue('hubspot_access_token', data.data.hubspot_access_token);
        }
        // Populate saved credentials on edit for the other auto-create providers
        if(['calendly','chargebee','ontraport','kajabi','typeform','woocommerce','shopify','hitpay','youform','housecallpro','ultracart','clickfunnels','thrivecart'].includes(processor)){
          processor_form.setFieldValue('login_id', data.data.login_id || '');
          processor_form.setFieldValue('transaction_key', data.data.transaction_key || '');
          processor_form.setFieldValue('access_token', data.data.access_token || '');
          processor_form.setFieldValue('secret_key', data.data.secret_key || '');
        }
        // Load destination webhooks (multi-select)
        if(data.data.destination_webhook_ids && Array.isArray(data.data.destination_webhook_ids) && data.data.destination_webhook_ids.length > 0) {
          setDestinationWebhookIds(data.data.destination_webhook_ids);
        } else {
          setDestinationWebhookIds([]);
        }
        // Load custom schema (fields + raw_json)
        if(data.data.custom_schema) {
          try {
            const schema = typeof data.data.custom_schema === 'string' ? JSON.parse(data.data.custom_schema) : data.data.custom_schema;
            if (schema.fields && Array.isArray(schema.fields)) {
              // New format: { fields: [...], raw_json: "..." }
              setCustomSchemaFields(schema.fields);
              savedDetectedJsonRef.current = schema.raw_json || '';
            } else if (Array.isArray(schema)) {
              // Legacy format: [{key, label}, ...] — no raw_json saved
              setCustomSchemaFields(schema);
              savedDetectedJsonRef.current = '';
            } else {
              setCustomSchemaFields([]);
              savedDetectedJsonRef.current = '';
            }
          } catch { setCustomSchemaFields([]); savedDetectedJsonRef.current = ''; }
        } else {
          setCustomSchemaFields([]);
          savedDetectedJsonRef.current = '';
        }
        // Expand advanced options if there's merge, rules, destination, or integration data
        const hasIntegrationData = data.data.login_id || data.data.secret_key || data.data.access_token || data.data.hubspot_access_token;
        if(data.data.link_webhook_id || data.data.webhook_rule_show || (data.data.destination_webhook_ids && data.data.destination_webhook_ids.length > 0) || hasIntegrationData) {
          setAdvancedOptionsOpen(true);
        }
        setSchemaWarning('');
        setPaymentProcessingCartLoader(false);
      }else{
        setPaymentProcessingCartLoader(false);
        notifications.show({
          color: 'red',
          icon: <IconX size="1.1rem" />,
          title: 'Error',
          message: data.message,
        });
      }
    })
    .catch(error => {
      console.log(error);
      setPaymentProcessingCartLoader(false);
    });
  };

  useEffect(() => {
    if (activeId === "custom") {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
    // Clear any post-save notice when moving to another provider or back to the listing
    setStripeSaveNotice(null);
  }, [activeId]);

  const [webhookRules, setWebhookRules] = useState([
    { field: "", condition: "", value: "" },
  ]);

  // Numeric Value Reporting: a score carried by the goal (lead quality, grade,
  // LTV...). Averaged, never summed, so it stays separate from revenue.
  const [numericValueEnabled, setNumericValueEnabled] = useState(false);
  const [numericValueField, setNumericValueField] = useState('');
  // Kept as strings so an empty box stays empty and never becomes a bound of 0.
  const [numericValueMin, setNumericValueMin] = useState('');
  const [numericValueMax, setNumericValueMax] = useState('');
  const [numericValueLabel, setNumericValueLabel] = useState('');
  // Advanced Options collapse state
  const [advancedOptionsOpen, setAdvancedOptionsOpen] = useState(false);

  // Persistent post-save notice for Stripe, shown in the block since toasts are easy to miss
  const [stripeSaveNotice, setStripeSaveNotice] = useState<{ warning: string, providerName: string } | null>(null);

  // Reuse credentials already saved on another webhook of the same processor
  const [reusableCredentials, setReusableCredentials] = useState<{ webhook_id: string, webhook_name: string }[]>([]);
  const [reuseCredentialWebhookId, setReuseCredentialWebhookId] = useState('');

  // Destination webhook forwarding (multi-select)
  const [destinationWebhookIds, setDestinationWebhookIds] = useState<string[]>([]);

  // Update Detected Fields modal
  const [detectedFieldsModalOpen, setDetectedFieldsModalOpen] = useState(false);
  const [detectedFieldsJson, setDetectedFieldsJson] = useState('');
  const [detectedFields, setDetectedFields] = useState<string[]>([]);
  const [customSchemaFields, setCustomSchemaFields] = useState<{key: string, label: string}[]>([]);
  const [schemaWarning, setSchemaWarning] = useState('');
  const [defaultProcessorJson, setDefaultProcessorJson] = useState('');
  const [clickfunnelsConversionType, setClickfunnelsConversionType] = useState('sales');
  const [conversionTypeSaleOptin, setConversionTypeSaleOptin] = useState('sale');
  const savedDetectedJsonRef = useRef('');

  // Flatten JSON to dot notation paths
  const flattenJson = (obj: any, prefix = ''): string[] => {
    let fields: string[] = [];
    for (const key in obj) {
      if (!obj.hasOwnProperty(key)) continue;
      const fullKey = prefix ? `${prefix}.${key}` : key;
      const value = obj[key];
      if (value !== null && typeof value === 'object' && !Array.isArray(value)) {
        fields = fields.concat(flattenJson(value, fullKey));
      } else if (!Array.isArray(value)) {
        fields.push(fullKey);
      }
    }
    return fields;
  };

  // Convert dot notation to readable label
  const dotToLabel = (path: string): string => {
    return path
      .split('.')
      .map(part => part.replace(/_/g, ' ').replace(/\b\w/g, c => c.toUpperCase()))
      .join(' → ');
  };

  const keyToLabel = (key: string): string =>
    dotToLabel(String(key).replace(/\['?([^'\]]*)'?\]/g, '.$1').replace(/^\./, ''));

  const handleOpenDetectedFields = () => {
    setDetectedFieldsModalOpen(true);
    setDetectedFields([]);

    const applyJson = (jsonSource: string) => {
      try {
        const parsed = JSON.parse(jsonSource);
        setDetectedFieldsJson(JSON.stringify(parsed, null, 2));
      } catch {
        setDetectedFieldsJson(jsonSource || '');
      }
    };

    // For existing webhooks: always fetch fresh from DB
    if (updateWebhookId) {
      SettingsApi.getsinglewebhookdetail({
        webhook_id: updateWebhookId
      })
      .then((response: any) => response.json())
      .then((data: any) => {
        if (data.status === 1 && data.data.custom_schema) {
          try {
            const schema = typeof data.data.custom_schema === 'string' ? JSON.parse(data.data.custom_schema) : data.data.custom_schema;
            if (schema.raw_json) {
              savedDetectedJsonRef.current = schema.raw_json;
              applyJson(schema.raw_json);
              return;
            }
          } catch {}
        }
        // No saved raw_json in DB — fall back to default
        applyJson(defaultProcessorJson);
      })
      .catch(() => {
        applyJson(savedDetectedJsonRef.current || defaultProcessorJson);
      });
    } else {
      // New webhook (not yet saved): use ref or default
      applyJson(savedDetectedJsonRef.current || defaultProcessorJson);
    }
  };

  const handleDetectFields = () => {
    try {
      const parsed = JSON.parse(detectedFieldsJson);
      const fields = flattenJson(parsed);
      if (fields.length === 0) {
        notifications.show({ color: 'red', icon: <IconX size="1.1rem" />, title: 'Error', message: 'No fields detected in JSON.' });
        return;
      }
      setDetectedFields(fields);
    } catch {
      notifications.show({ color: 'red', icon: <IconX size="1.1rem" />, title: 'Error', message: 'Invalid JSON. Please paste a valid webhook payload.' });
    }
  };

  const handleSaveDetectedFields = () => {
    const newSchema = detectedFields.map(f => ({ key: f, label: dotToLabel(f) }));
    setCustomSchemaFields(newSchema);

    // Persist the raw JSON so modal can reload it later
    savedDetectedJsonRef.current = detectedFieldsJson;

    // Check if existing rules reference fields no longer in schema
    const validKeys = new Set(detectedFields);
    const invalidRules = webhookRules.filter(r => r.field && !validKeys.has(r.field));
    if (invalidRules.length > 0) {
      setSchemaWarning('Some rules reference fields that no longer exist in the detected schema.');
    } else {
      setSchemaWarning('');
    }

    // Persist to DB immediately (webhook-wise) so it survives navigation
    if (updateWebhookId) {
      const schemaPayload = JSON.stringify({ fields: newSchema, raw_json: detectedFieldsJson });
      SettingsApi.savewebhookschema({
        webhook_id: updateWebhookId,
        custom_schema: schemaPayload
      })
      .then((response: any) => response.json())
      .then((data: any) => {
        if (data.status !== 1) {
          notifications.show({ color: 'red', icon: <IconX size="1.1rem" />, title: 'Error', message: data.message || 'Failed to save schema.' });
        }
      })
      .catch(() => {
        notifications.show({ color: 'red', icon: <IconX size="1.1rem" />, title: 'Error', message: 'Failed to save schema to server.' });
      });
    }

    setDetectedFieldsModalOpen(false);
    setDetectedFieldsJson('');
    setDetectedFields([]);
    notifications.show({ color: 'green', icon: <IconCheck size="1.1rem" />, title: 'Success', message: `${newSchema.length} fields detected and saved.` });
  };

  const handleWebhookRules = (index, field, value) => {
    const updated = [...webhookRules];
    updated[index][field] = value;
    setWebhookRules(updated);
  };

  const handleAddFilter = () => {
    setWebhookRules([...webhookRules, { field: "", condition: "", value: "" }]);
  };

  const handleRemoveFilter = (index) => {
    setWebhookRules(webhookRules.filter((_, i) => i !== index));
  };

  const createWebhookForm = (processor:any, webhookHelpName) => {
    // Shared handler for the Sale/Opt-in dropdown: save the value and refresh the rule-builder fields
    const onConversionTypeChange = (ct: string) => { setConversionTypeSaleOptin(ct); getWebhookMappingData(processor, ct); };
    let processor_form = [] as any;
    if(processor === 'authorize'){
      processor_form = forms['authorize_net'];
    }else{
      processor_form = forms[processor];
    }

    const hiddenCheckboxProcessors = ["gohighlevel","hitpay","housecallpro","katra","merchantx","samcart","shopify","stripe","ultracart","kajabi","paypal"];
    const showSubscriptionCheckbox = hiddenCheckboxProcessors.includes(processor);

    // Build field dropdown: use custom schema if available, otherwise default mapping
    const fieldDropdownData = customSchemaFields.length > 0
      ? [{ value: '', label: 'Select Field', disabled: true }, ...customSchemaFields.map(f => ({ value: f.key, label: f.label }))]
      : selectWebhookMappingData.map((o: any) => (o.value ? { value: o.value, label: keyToLabel(o.value) } : o));

    // Filter destination dropdown: same processor only + exclude current webhook (loop protection)
    const destinationDropdownData = Object.entries(webhookListData)
      .filter(([, item]: any) => {
        if (!item.webhook_name || item.webhook_name === '-') return false;
        if (!item.processor) return false;
        if (updateWebhookId && item.webhook_id === updateWebhookId) return false;
        if (processor && item.processor.toLowerCase() !== String(processor).toLowerCase()) return false;
        return true;
      })
      .map(([, item]: any) => ({ value: item.webhook_id, label: item.webhook_name }));

  	return(
  		<>
        {/* ═══════════ BASIC SETUP ═══════════ */}
  			<Group spacing="xs" mb={10}>
  	    	<Text size="sm" fz={14} fw={500} mb={10} w={221}>Enter Webhook Name: </Text>
  	      <TextInput w={250} ml={0} {...processor_form.getInputProps('webhook_name')} value={processor_form.values.webhook_name} onChange={(event) => processor_form.setFieldValue('webhook_name', event.currentTarget.value)}/>
  	    </Group>
  	    <Group spacing="xs" mb={10}>
  	    	<Text size="sm" fz={14} fw={500} mb={10} w={220}>Select a Funnel: </Text>
  	      <MultiSelect
            searchable
            style={{ width: '21%' }}
			      data={multiSelectFunnelData}
			      value={processor_form.values.selected_funnels}
			      onChange={(values) => processor_form.setFieldValue('selected_funnels', values)}
			    />
  	    </Group>
  	    <Group spacing="xs" mb={10}>
  	    	<Text size="sm" fz={14} fw={500} mb={10} w={220}>Record Unique Conversions Only: </Text>
  	      <Switch
	          size="md"
	          onLabel="ON"
	          offLabel="OFF"
	          style={{ marginBottom: 3 }}
	          checked={processor_form.values.unique_conversion}
	          onChange={(event) => processor_form.setFieldValue('unique_conversion', event.currentTarget.checked)}
	        />
  	    </Group>
  	    <Group spacing="xs" mb={10} ref={countAsPurchaseRef}
  	      style={highlightWebhookId !== '' && highlightWebhookId === updateWebhookId
  	        ? { outline: '2px solid #fab005', outlineOffset: 4, borderRadius: 6, background: 'rgba(250, 176, 5, 0.12)' } : undefined}>
  	    	<Text size="sm" fz={14} fw={500} mb={10} w={220}>Count as Purchase: </Text>
  	      <Switch
	          size="md"
	          onLabel="ON"
	          offLabel="OFF"
	          style={{ marginBottom: 3 }}
	          checked={!!processor_form.values.count_as_purchase}
	          onChange={(event) => processor_form.setFieldValue('count_as_purchase', event.currentTarget.checked)}
	        />
	        <Text size="xs" color="dimmed" mb={10} style={{ maxWidth: 560 }}>
	          Turn on only if this webhook records a sale. Leave off for leads, sign-ups or booked calls. If two webhooks report the same order, turn it on for only one.
	        </Text>
  	    </Group>
        {showSubscriptionCheckbox && (
        <Group spacing="xs" mb={10}>
          <Text size="sm" fz={14} fw={500} mb={10} w={220}>Show as a subscription: </Text>
          <Checkbox
            name="subscription_show"
            checked={!!processor_form.values.subscription_show}
            onChange={(event) => {
              const isChecked = event.currentTarget.checked;
              processor_form.setFieldValue('subscription_show', isChecked);
              if (!isChecked) {
                processor_form.setFieldValue('selected_subscription_duration', '');
              }
            }}
          />
        </Group>
         )}
        {showSubscriptionCheckbox && processor_form.values.subscription_show && (
        <Group spacing="xs" mb={10}>
          <Text size="sm" fz={14} fw={500} mb={10} w={220}>Subscription Duration: </Text>
          <Select
            style={{ width: '21%' }}
            data={selectSubscriptionDurationListData}
            value={processor_form.values.selected_subscription_duration}
            onChange={(value) => processor_form.setFieldValue('selected_subscription_duration', value)}
          />
        </Group>
        )}

            {/* --- D. Integrations (dynamic per processor) --- */}
            {(() => {
              // Per-provider credential fields, required/optional lists and help come from the shared config
              const requiredCredentialProcessors = REQUIRED_CREDENTIAL_PROCESSORS;
              const autoCreateProcessors = AUTO_CREATE_PROCESSORS;
              const fields = WEBHOOK_INTEGRATION_FIELDS[processor as string];
              if (!fields) return null;
              if (processor === 'shopify') return null;
              return (
                <>
                  <Divider my="md" variant="dashed" />
                  <Text size="sm" fw={600} mb={8}>Integrations</Text>
                  {processor === 'clickfunnels' && (
                    <Text size="xs" c="dimmed" mb={12} style={{ lineHeight: 1.6 }}>
                      The credentials below are only needed if you're on ClickFunnels 2.0 and want Visiopt to create the webhook automatically. On ClickFunnels Classic, skip them and follow the manual setup steps.
                    </Text>
                  )}
                  {reusableCredentials.length > 0 && (
                    <Group spacing="sm" mb={14} align="center" noWrap>
                      <Text size="sm" fz={14} fw={500} w={220} style={{ flexShrink: 0 }}>Reuse credentials from:</Text>
                      <Select w={320} ml={0} size="sm" radius="sm"
                        data={[{ value: '', label: 'Enter new credentials' }].concat(reusableCredentials.map((rc) => ({ value: rc.webhook_id, label: rc.webhook_name })))}
                        value={reuseCredentialWebhookId}
                        onChange={(val: any) => setReuseCredentialWebhookId(val || '')}
                      />
                    </Group>
                  )}
                  {reuseCredentialWebhookId !== '' ? (
                    <Text size="xs" color="dimmed" mb={10}>Using the saved credentials from the selected webhook. Choose "Enter new credentials" above to enter your own instead.</Text>
                  ) : (
                  fields.map((field) => (
                    <Group spacing="sm" mb={14} key={field.key} align="center" noWrap>
                      <Text size="sm" fz={14} fw={500} w={220} style={{ flexShrink: 0 }}>
                        {field.label}:{requiredCredentialProcessors.includes(processor as string) ? <span style={{color:'#fa5252'}}> *</span> : autoCreateProcessors.includes(processor as string) ? <span style={{color:'#868e96',fontWeight:400,fontSize:12}}> (Optional)</span> : null}
                      </Text>
                      {field.type === 'text' ? (
                        <TextInput w={320} ml={0} size="sm" radius="sm"
                          placeholder={field.placeholder}
                          value={processor_form.values[field.key] || ''}
                          onChange={(event: any) => processor_form.setFieldValue(field.key, event.currentTarget.value)}
                        />
                      ) : field.type === 'select' && field.options ? (
                        <Select w={320} ml={0} size="sm" radius="sm"
                          data={field.options}
                          value={processor_form.values[field.key] || ''}
                          onChange={(val: any) => processor_form.setFieldValue(field.key, val)}
                        />
                      ) : null}
                      {field.help && (
                        <Popover width={340} position="right" withArrow shadow="md">
                          <Popover.Target>
                            <ActionIcon variant="light" color="blue" size="md" radius="sm" title={field.help.title}>
                              <IconHelp size="1.1rem" />
                            </ActionIcon>
                          </Popover.Target>
                          <Popover.Dropdown>
                            <Text size="sm" fw={600} mb={6}>{field.help.title}</Text>
                            {field.help.steps.map((step, stepIndex) => (
                              <Text size="xs" mb={4} key={stepIndex}>{step}</Text>
                            ))}
                            {field.help.link && (
                              <Anchor href={field.help.link} target="_blank" rel="noopener noreferrer" size="xs">{field.help.linkLabel || 'Open documentation'}</Anchor>
                            )}
                          </Popover.Dropdown>
                        </Popover>
                      )}
                    </Group>
                  )))}
                  {CONVERSION_TYPE_PROCESSORS.includes(processor as string) && (
                    <ConversionTypeField value={conversionTypeSaleOptin} onChange={onConversionTypeChange} />
                  )}
                </>
              );
            })()}
        {/* Shopify auto-creates via the connected app, so its Conversion Type must be set here (not under rules) */}
        {processor === 'shopify' && (
          <>
            <Divider my="md" variant="dashed" />
            <ConversionTypeField
              value={conversionTypeSaleOptin}
              onChange={onConversionTypeChange}
              note="Visiopt auto-creates the matching Shopify webhook (orders/paid vs customers/create) when your store is connected, so set this before saving."
            />
          </>
        )}
        {/* ═══════════ ADVANCED OPTIONS (Collapsible) ═══════════ */}
        <Divider my="md" />
        <Button
          variant="subtle"
          color="dark"
          compact
          onClick={() => setAdvancedOptionsOpen(!advancedOptionsOpen)}
          rightIcon={advancedOptionsOpen ? <IconChevronUp size={16} /> : <IconChevronDown size={16} />}
          mb="sm"
          styles={{ root: { fontWeight: 600, fontSize: 14, padding: 0 } }}
        >
          Advanced Options
        </Button>

        <Collapse in={advancedOptionsOpen}>
          <Box pl="xs" style={{ borderLeft: '2px solid #e9ecef' }}>

            {/* --- Intro shown when Advanced Options is expanded --- */}
            <Text size="sm" fw={600} mt="sm" mb={4}>Advanced Webhook Settings:</Text>
            <Text size="xs" color="dimmed" mb={6}>
              Need more control over how conversions are tracked and reported? Advanced Webhook Settings help you solve common tracking challenges that standard webhook setups can&apos;t handle.
            </Text>
            <Text size="xs" color="dimmed" mb={2}>For example, you can:</Text>
            <Text size="xs" color="dimmed" ml="sm"><Text span size="xs" fw={700} color={colorTheme === "light" ? "dark" : "gray.4"}>• Combine</Text> multiple webhooks into a single reporting goal.</Text>
            <Text size="xs" color="dimmed" ml="sm"><Text span size="xs" fw={700} color={colorTheme === "light" ? "dark" : "gray.4"}>• Track</Text> individual products, plans, or form answers separately from a single webhook.</Text>
            <Text size="xs" color="dimmed" ml="sm" mb={6}><Text span size="xs" fw={700} color={colorTheme === "light" ? "dark" : "gray.4"}>• Work around</Text> carts, forms, or CRMs that only allow one webhook connection.</Text>
            <Text size="xs" color="dimmed">
              These tools give you greater flexibility in how conversion data is organized and reported inside Visiopt.
            </Text>

            <Divider my="md" variant="dashed" />

            {/* --- A. Score & Rating Reporting ---
                Only on webhook types that can carry a score: CRM, form and funnel
                tools, where a lead is rated after it converts. Payment processors
                and carts fire at the moment of purchase, before anything has been
                rated, so they never hold a score. This list must match the capture
                files that read the setting, or someone could switch it on where it
                silently does nothing. */}
            {SCORE_RATING_PROCESSORS.includes(processor) && (
            <>
            <Text size="sm" fw={600} mt="sm" mb={4}>Score &amp; Rating Reporting</Text>
            <Text size="xs" color="dimmed" mb="sm">
              Use this when your webhook sends a score or rating rather than an amount &mdash; lead quality, a grade, or any rating. Visiopt reports the values it receives against the ad, campaign and source that produced them.
            </Text>
            <Text size="xs" color="dimmed" mb="sm">
              If your field sends words instead of numbers, Visiopt shows a percentage breakdown of those labels instead of an average.
            </Text>

            <Group spacing="xs" mb={10}>
              <Text size="sm" fz={14} fw={500} w={220}>Enable Score &amp; Rating: <HelpTip helpId={387} /></Text>
              <Checkbox
                name="numeric_value_enabled"
                checked={numericValueEnabled}
                onChange={(event) => setNumericValueEnabled(event.currentTarget.checked)}
              />
            </Group>

            {numericValueEnabled && (
              <>
                <Group spacing="xs" mb={10}>
                  <Text size="sm" fz={14} fw={500} mb={10} w={220}>Value Field: </Text>
                  <TextInput
                    style={{ width: '21%' }}
                    placeholder="Field name"
                    required={processor !== 'hubspot'}
                    error={processor !== 'hubspot' && numericValueEnabled && numericValueField.trim() === '' ? 'Required for this webhook type' : false}
                    value={numericValueField}
                    onChange={(event) => setNumericValueField(event.currentTarget.value)}
                  />
                </Group>
                <Text size="xs" color="dimmed" mb="sm" ml={228}>
                  {processor === 'hubspot'
                    ? 'The field in the incoming data that holds the value. Leave blank for HubSpot — it is detected automatically.'
                    : 'The field in the incoming data that holds the value. Required — only HubSpot is detected automatically.'}
                </Text>

                {/* No Aggregation field on screen. Average is the only behaviour,
                    and showing a one-option setting implies there are others.
                    Repeat values are handled by Record Unique Conversion, not by
                    an aggregation choice. The stored value stays 'average'. */}

                <Group spacing="xs" mb={10}>
                  <Text size="sm" fz={14} fw={500} mb={10} w={220}>Minimum Allowed Value: </Text>
                  <TextInput
                    style={{ width: '21%' }}
                    placeholder="No minimum"
                    value={numericValueMin}
                    onChange={(event) => setNumericValueMin(event.currentTarget.value)}
                  />
                </Group>

                <Group spacing="xs" mb={10}>
                  <Text size="sm" fz={14} fw={500} mb={10} w={220}>Maximum Allowed Value: </Text>
                  <TextInput
                    style={{ width: '21%' }}
                    placeholder="No maximum"
                    value={numericValueMax}
                    onChange={(event) => setNumericValueMax(event.currentTarget.value)}
                  />
                </Group>

                <Text size="xs" color="dimmed" mb="sm">
                  On a numeric field, values outside the allowed range and anything that is not a number are left out of the average. The conversion is still counted, and the report shows how many conversions carried a usable value.
                </Text>

                <Group spacing="xs" mb={10}>
                  <Text size="sm" fz={14} fw={500} mb={10} w={220}>Display Name: </Text>
                  <TextInput
                    style={{ width: '21%' }}
                    placeholder="Score and Rating"
                    maxLength={100}
                    value={numericValueLabel}
                    onChange={(event) => setNumericValueLabel(event.currentTarget.value)}
                  />
                </Group>
                <Text size="xs" color="dimmed" mb="sm" ml={228}>
                  Optional. Used as the column header in reports. Leave blank to show "Score and Rating".
                </Text>
              </>
            )}

            <Divider my="md" variant="dashed" />
            </>
            )}

            {/* --- A. Merge Webhooks --- */}
            <Text size="sm" fw={600} mt="sm" mb={6}>Merge Webhooks  <HelpTip helpId={380} /></Text>
            <Group spacing="xs" mb={10}>
              <Text size="sm" fz={14} fw={500} mb={10} w={220}>Select Webhook: </Text>
              <Select
                style={{ width: '21%' }}
                data={selectWebhookListData}
                value={processor_form.values.selected_webhook}
                onChange={(value) => processor_form.setFieldValue('selected_webhook', value)}
              />
            </Group>

            <Divider my="md" variant="dashed" />

            {/* --- B. Webhook Rules --- */}
            <Text size="sm" fw={600} mb={4}>Webhook Rules <HelpTip helpId={378} /></Text>
            <Text size="xs" color="dimmed" mb="sm">Use rules to separate a single webhook into multiple tracked results in Visiopt based on products, answers, or other criteria.</Text>

            <Group spacing="xs" mb={10}>
              <Text size="sm" fz={14} fw={500} mb={10} w={220}>Enable Rules: </Text>
              <Checkbox
                name="webhook_rule"
                checked={!!processor_form.values.webhook_rule}
                onChange={(event) => {
                  const checked = event.currentTarget.checked;
                  processor_form.setFieldValue('webhook_rule', checked);
                  if (!checked) {
                    setWebhookRules([{ field: "", condition: "", value: "" }]);
                    setSchemaWarning('');
                  }
                }}
              />
            </Group>

            {processor_form.values.webhook_rule && (
              <>
                {/* Sale vs Opt-in for manual providers with no Integration block (Kartra, SamCart).
                    Shopify auto-creates, so its dropdown lives above (always visible), not here. */}
                {CONVERSION_TYPE_PROCESSORS.includes(processor as string) && !WEBHOOK_INTEGRATION_FIELDS[processor as string] && (
                  <ConversionTypeField value={conversionTypeSaleOptin} onChange={onConversionTypeChange} />
                )}
                {/* ClickFunnels: choose which webhook payload the rule builder maps against */}
                {processor === 'clickfunnels' && (
                  <Group spacing="xs" mb={10}>
                    <Text size="sm" fz={14} fw={500} mb={10} w={220}>Conversion Type: </Text>
                    <Select
                      style={{ width: '25%' }}
                      data={[
                        { value: 'sales', label: 'Sales (Purchase Created) (ClickFunnels Classic)' },
                        { value: 'optin', label: 'Opt-in (Contact Created) (ClickFunnels Classic)' },
                        { value: 'sales_2', label: 'Sales (Order Created) (ClickFunnels 2.0)' },
                        { value: 'optin_2', label: 'Opt-in (Contact Created) (ClickFunnels 2.0)' },
                      ]}
                      value={clickfunnelsConversionType}
                      onChange={(val) => {
                        const ct = val || 'sales';
                        setClickfunnelsConversionType(ct);
                        // Available fields change with the payload, so clear rules/schema tied to the old one.
                        setWebhookRules([{ field: "", condition: "", value: "" }]);
                        setCustomSchemaFields([]);
                        savedDetectedJsonRef.current = '';
                        setSchemaWarning('');
                        getWebhookMappingData('clickfunnels', ct);
                      }}
                    />
                  </Group>
                )}

                {/* Schema warning banner */}
                {schemaWarning && (
                  <Alert icon={<IconAlertTriangle size={16} />} color="yellow" mb="sm">
                    {schemaWarning}
                  </Alert>
                )}

                {webhookRules.map((rule, index) => (
                  <Group spacing="xs" mb={10} key={index}>
                    <Select
                      style={{ width: '21%' }}
                      data={fieldDropdownData}
                      value={rule.field}
                      searchable
                      onChange={(val) => {
                        handleWebhookRules(index, "field", val);
                        // Clear warning if field is now valid
                        if (schemaWarning && customSchemaFields.length > 0) {
                          const validKeys = new Set(customSchemaFields.map(f => f.key));
                          const updated = [...webhookRules];
                          updated[index] = { ...updated[index], field: val || '' };
                          const stillInvalid = updated.filter(r => r.field && !validKeys.has(r.field));
                          if (stillInvalid.length === 0) setSchemaWarning('');
                        }
                      }}
                    />
                    <Select
                      style={{ width: '21%' }}
                      data={[
                        { value: '', label: 'Select condition', disabled: true },
                        { value: 'greater_than_or_equal_to', label: 'Greater than or equal to' },
                        { value: 'less_than_or_equal_to', label: 'Less than or equal to' },
                        { value: 'includes', label: 'Includes' },
                        { value: 'excludes', label: 'Excludes (ignore)' },
                      ]}
                      value={rule.condition}
                      onChange={(val) => handleWebhookRules(index, "condition", val)}
                    />
                    <TextInput w={250} ml={0}
                      value={rule.value}
                      onChange={(e) => handleWebhookRules(index, "value", e.currentTarget.value)}
                    />
                    <Button color="teal" onClick={handleAddFilter} size="sm">
                      <IconPlus size="1.1rem" color="white"/><Text ml={2}>and</Text>
                    </Button>
                    {webhookRules.length > 1 && (
                      <ActionIcon title="Remove" onClick={() => handleRemoveFilter(index)}>
                        <IconCircleMinus size="1.1rem" color="red" />
                      </ActionIcon>
                    )}
                  </Group>
                ))}

                {/* Update Detected Fields button */}
                <Button variant="light" size="xs" compact mb="md" mr={5} onClick={handleOpenDetectedFields}>
                  Update Detected Fields
                </Button>
                <HelpTip helpId={379} />

              </>
            )}

            {/* --- C. Destination Webhooks (independent of rules) --- */}
            <Divider my="md" variant="dashed" />
            <Text size="sm" fw={600} mb={6}>Destination Webhooks</Text>
            <Group spacing="xs" mb={10}>
              <Text size="sm" fz={14} fw={500} w={220}>Forward To: <HelpTip helpId={381} /></Text>
              <MultiSelect
                style={{ width: '30%' }}
                searchable
                placeholder="Select webhooks to forward to"
                data={destinationDropdownData}
                value={destinationWebhookIds}
                onChange={(values) => setDestinationWebhookIds(values)}
              />
            </Group>


          </Box>
        </Collapse>
  		</>
  	);
  }

  const webhookTableData = (webhookUrlListData:any, webhookProcessor:any, loading, activePage:any) => {
    const paginatedData = Object.entries(webhookUrlListData).slice(
      (activePage - 1) * itemsPerPage,
      activePage * itemsPerPage
    );

  	return(
      <div style={{ overflowY: "auto", maxWidth: '1200px'}}>
        {/* Post-save notice, scoped to this provider's block so it never leaks to the listing or other providers */}
        {stripeSaveNotice && PROVIDER_DISPLAY_NAMES[webhookProcessor] === stripeSaveNotice.providerName && (
          stripeSaveNotice.warning ? (
            <Alert icon={<IconX size={16} />} color="red" mt="md" mb="xs" withCloseButton onClose={() => setStripeSaveNotice(null)}>
              {webhookProcessor === 'shopify' ? (
                <>
                  <Text weight={700} mb="xs">We were unable to create the Shopify webhook automatically.</Text>
                  Please create the webhook manually in your Shopify store using the webhook URL shown in the list below.
                </>
              ) : (
                <>
                  <Text weight={700} mb="xs">The {stripeSaveNotice.providerName} webhook could not be created automatically.</Text>
                  {stripeSaveNotice.warning} Your VisiOpt configuration was still saved. You can create the webhook manually in your {stripeSaveNotice.providerName} account using the webhook URL shown in the list below.
                </>
              )}
            </Alert>
          ) : (
            <Alert icon={webhookProcessor === 'shopify' ? <IconCheck size={16} /> : <IconAlertTriangle size={16} />} color={webhookProcessor === 'shopify' ? 'green' : 'blue'} mt="md" mb="xs" withCloseButton onClose={() => setStripeSaveNotice(null)}>
              {webhookProcessor === 'shopify' ? (
                <>
                  <Text weight={700} mb="xs">Shopify webhook has been created successfully.</Text>
                  No further action is required. Please do not create the webhook manually in your Shopify store, as that would create a duplicate webhook.
                </>
              ) : (
                <>
                  <Text weight={700} mb="xs">Verify your {stripeSaveNotice.providerName} webhook</Text>
                  Your configuration has been saved successfully. If no error is shown here, please log in to your {stripeSaveNotice.providerName} account and verify that the VisiOpt webhook has been created. If you do not see it, create it manually using the webhook URL shown in the list below.
                </>
              )}
            </Alert>
          )
        )}
    		<Table striped highlightOnHover withBorder withColumnBorders mt={20}>
        	<thead>
        		<tr>
        			<th>No</th>
              <th>Webhook Name</th>
              <th>Webhook URL</th>
              <th>Funnel Name</th>
              <th>Tests & Campaign Name</th>
              <th>Verification</th>
              <th>Action</th>
        		</tr>
        	</thead>
        	<tbody>
        	{loading ? (
            Array.from({ length: 10 }).map((_, idx) => (
               <tr key={idx}>
                <td colSpan={7}>
                  <Skeleton height={44} width="100%" />
                </td>
              </tr>
            ))
          ) : paginatedData.length > 0 ? (
        			paginatedData.map(([_, urlData], urlIndex) => {
                const data = urlData as {
                  id: string;
                  webhook_name: string;
                  webhook_url: string;
                  funnel_name: string;
                  webhook_id: string;
                  verification_status?: number;
                  test_campaign_details?: { test?: string; campaign?: string };
                };
                const isVerified = Number(data.verification_status) === 1;
                return (
                  <tr key={urlIndex}>
                    <td>{data.id}</td>
                    <td>{data.webhook_name}</td>
                    <td style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '5px' }}>
                      <span>{data.webhook_url}</span>
                      <CopyButton timeout={5000} value={data.webhook_url}>
                        {({ copied, copy }) => (
                          <Tooltip label={copied ? 'Copied' : 'Copy webhook URL'} withArrow>
                            <ActionIcon
                              variant="filled"
                              color={copied ? 'teal' : 'blue'}
                              size="lg"
                              onClick={copy}
                              title="Copy webhook URL"
                            >
                              {copied ? <IconCheck size="1.1rem" /> : <IconCopy size="1.1rem" />}
                            </ActionIcon>
                          </Tooltip>
                        )}
                      </CopyButton>
                    </td>
                    <td>{data.funnel_name}</td>
                    <td>
                      {data.test_campaign_details?.test && (
                        <>
                          <Text weight={800}>Tests: </Text>
                          <Text>{data.test_campaign_details.test}</Text>
                        </>
                      )}
                      {data.test_campaign_details?.campaign && (
                        <>
                          <Text weight={800}>Campaign: </Text>
                          <Text>{data.test_campaign_details.campaign}</Text>
                        </>
                      )}
                    </td>
                    <td>
                      {isVerified ? (
                        <Badge color="green" variant="light" leftSection={<IconCheck size="0.8rem" />}>Verified</Badge>
                      ) : (
                        <Group spacing={6} noWrap>
                          <Tooltip label="Verification happens automatically after the first webhook event is received." multiline width={240} withArrow>
                            <Badge color="yellow" variant="light">Waiting for First Event</Badge>
                          </Tooltip>
                          <Tooltip label="Refresh verification status" withArrow>
                            <ActionIcon
                              variant="subtle"
                              size="sm"
                              title="Refresh verification status"
                              loading={refreshingWebhookId === data.webhook_id}
                              onClick={() => refreshVerificationStatus(data.webhook_id)}
                            >
                              <IconRefresh size="1rem" />
                            </ActionIcon>
                          </Tooltip>
                        </Group>
                      )}
                    </td>
                    <td>
                      <Flex
                        justify="center"
                        align="center"
                        direction="row"
                        wrap="wrap"
                      >
                        <ActionIcon
                          variant="default"
                          size="lg"
                          mx={3}
                          title="Edit"
                          onClick={() => handleEditWebhook(data.webhook_id, webhookProcessor)}
                        >
                          <IconPencil size="1.1rem" />
                        </ActionIcon>
                        <ActionIcon
                          variant="default"
                          size="lg"
                          mx={3}
                          title="Delete"
                          onClick={() => {
                            deleteCustomWebhookDelete(data.webhook_id, webhookProcessor);
                            setUpdateWebhookId('');
                            Object.values(forms).forEach((form) => form.reset());
                          }}
                        >
                          <IconTrash size="1.1rem" />
                        </ActionIcon>
                      </Flex>
                    </td>
                  </tr>
                );
                })
            ) : (
              <tr>
                <td colSpan={7} style={{ textAlign: 'center', padding: '10px' }}>
                  No Data Found
                </td>
              </tr>
            )}
        	</tbody>
        </Table>
      </div>
  	);
  }

  const webhookEntries = Object.entries(webhookUrlListData);
  const totalPagesAuthorize = Math.ceil(webhookEntries.length / itemsPerPage);
  const totalPagesHubSpot = Math.ceil(webhookEntries.length / itemsPerPage);
  const totalPagesChargebee = Math.ceil(webhookEntries.length / itemsPerPage);
  const totalPagesStripe = Math.ceil(webhookEntries.length / itemsPerPage);
  const totalPagesCustomCart = Math.ceil(webhookEntries.length / itemsPerPage);
  const totalPagesWoocommerce = Math.ceil(webhookEntries.length / itemsPerPage);
  const totalPagesThriveCart = Math.ceil(webhookEntries.length / itemsPerPage);
  const totalPagesEasypaydirect = Math.ceil(webhookEntries.length / itemsPerPage);
  const totalPagesHitpay = Math.ceil(webhookEntries.length / itemsPerPage);
  const totalPagesHousecallpro = Math.ceil(webhookEntries.length / itemsPerPage);
  const totalPagesMerchantx = Math.ceil(webhookEntries.length / itemsPerPage);
  const totalPagesPaypal = Math.ceil(webhookEntries.length / itemsPerPage);
  const totalPagesGocardless = Math.ceil(webhookEntries.length / itemsPerPage);
  const totalPagesRecurly = Math.ceil(webhookEntries.length / itemsPerPage);
  const totalPagesCalendly = Math.ceil(webhookEntries.length / itemsPerPage);
  const totalPagesBuygoods = Math.ceil(webhookEntries.length / itemsPerPage);
  const totalPagesClickbank = Math.ceil(webhookEntries.length / itemsPerPage);
  const totalPagesClickfunnels = Math.ceil(webhookEntries.length / itemsPerPage);
  const totalPagesGohighlevel = Math.ceil(webhookEntries.length / itemsPerPage);
  const totalPagesDigistore24 = Math.ceil(webhookEntries.length / itemsPerPage);
  const totalPagesKartra = Math.ceil(webhookEntries.length / itemsPerPage);
  const totalPagesKonnektive = Math.ceil(webhookEntries.length / itemsPerPage);
  const totalPageskajabi = Math.ceil(webhookEntries.length / itemsPerPage);
  const totalPagesOntraport = Math.ceil(webhookEntries.length / itemsPerPage);
  const totalPagesUltracart = Math.ceil(webhookEntries.length / itemsPerPage);
  const totalPagesShopify = Math.ceil(webhookEntries.length / itemsPerPage);
  const totalPagesSamcart = Math.ceil(webhookEntries.length / itemsPerPage);
  const totalPagesStealthseminar = Math.ceil(webhookEntries.length / itemsPerPage);
  const totalPagesPaykickstart = Math.ceil(webhookEntries.length / itemsPerPage);
  const totalPagesTypeform = Math.ceil(webhookEntries.length / itemsPerPage);
  const totalPagesYouform = Math.ceil(webhookEntries.length / itemsPerPage);

  const handlePageChangeAuthorize = (page) => {
    setLoading(true);
    setActivePageAuthorize(page);
    setTimeout(() => {
      setLoading(false);
    }, 500);
  };

  const handlePageChangeChargebee = (page) => {
    setLoading(true);
    setActivePageChargebee(page);
    setTimeout(() => {
      setLoading(false);
    }, 500);
  };

  const handlePageChangeStripe = (page) => {
    setLoading(true);
    setActivePageStripe(page);
    setTimeout(() => {
      setLoading(false);
    }, 500);
  };

  const handlePageChangeCustomCart = (page) => {
    setLoading(true);
    setActivePageCustomCart(page);
    setTimeout(() => {
      setLoading(false);
    }, 500);
  };

  const handlePageChangeHubSpot = (page) => {
    setLoading(true);
    setActivePageHubSpot(page);
    setTimeout(() => {
      setLoading(false);
    }, 500);
  };

  const handlePageChangeWoocommerce = (page) => {
    setLoading(true);
    setActivePageWoocommerce(page);
    setTimeout(() => {
      setLoading(false);
    }, 500);
  };

  const handlePageChangeThriveCart = (page) => {
    setLoading(true);
    setActivePageThriveCart(page);
    setTimeout(() => {
      setLoading(false);
    }, 500);
  };

  const handlePageChangeEasypaydirect = (page) => {
    setLoading(true);
    setActivePageEasypaydirect(page);
    setTimeout(() => {
      setLoading(false);
    }, 500);
  };

  const handlePageChangeHitpay = (page) => {
    setLoading(true);
    setActivePageHitpay(page);
    setTimeout(() => {
      setLoading(false);
    }, 500);
  };

  const handlePageChangeHousecallpro = (page) => {
    setLoading(true);
    setActivePageHousecallpro(page);
    setTimeout(() => {
      setLoading(false);
    }, 500);
  };

  const handlePageChangeMerchantx = (page) => {
    setLoading(true);
    setActivePageMerchantx(page);
    setTimeout(() => {
      setLoading(false);
    }, 500);
  };

  const handlePageChangeGocardless = (page) => {
    setLoading(true);
    setActivePageGocardless(page);
    setTimeout(() => {
      setLoading(false);
    }, 500);
  };

  const handlePageChangePaypal = (page) => {
    setLoading(true);
    setActivePagePaypal(page);
    setTimeout(() => {
      setLoading(false);
    }, 500);
  };

  const handlePageChangeRecurly = (page) => {
    setLoading(true);
    setActivePageRecurly(page);
    setTimeout(() => {
      setLoading(false);
    }, 500);
  };

  const handlePageChangeBuygoods = (page) => {
    setLoading(true);
    setActivePageBuygoods(page);
    setTimeout(() => {
      setLoading(false);
    }, 500);
  };

  const handlePageChangeCalendly = (page) => {
    setLoading(true);
    setActivePageCalendly(page);
    setTimeout(() => {
      setLoading(false);
    }, 500);
  };

  const handlePageChangeClickfunnels = (page) => {
    setLoading(true);
    setActivePageClickfunnels(page);
    setTimeout(() => {
      setLoading(false);
    }, 500);
  };

  const handlePageChangeClickbank = (page) => {
    setLoading(true);
    setActivePageClickbank(page);
    setTimeout(() => {
      setLoading(false);
    }, 500);
  };

  const handlePageChangeDigistore24 = (page) => {
    setLoading(true);
    setActivePageDigistore24(page);
    setTimeout(() => {
      setLoading(false);
    }, 500);
  };

  const handlePageChangeGohighlevel = (page) => {
    setLoading(true);
    setActivePageGohighlevel(page);
    setTimeout(() => {
      setLoading(false);
    }, 500);
  };

  const handlePageChangeKartra = (page) => {
    setLoading(true);
    setActivePageKartra(page);
    setTimeout(() => {
      setLoading(false);
    }, 500);
  };

  const handlePageChangeKonnektive = (page) => {
    setLoading(true);
    setActivePageKonnektive(page);
    setTimeout(() => {
      setLoading(false);
    }, 500);
  };

  const handlePageChangeKajabi = (page) => {
    setLoading(true);
    setActivePageKajabi(page);
    setTimeout(() => {
      setLoading(false);
    }, 500);
  };

  const handlePageChangeOntraport = (page) => {
    setLoading(true);
    setActivePageOntraport(page);
    setTimeout(() => {
      setLoading(false);
    }, 500);
  };

  const handlePageChangePaykickstart = (page) => {
    setLoading(true);
    setActivePagePaykickstart(page);
    setTimeout(() => {
      setLoading(false);
    }, 500);
  };

  const handlePageChangeTypeform = (page) => {
    setLoading(true);
    setActivePageTypeform(page);
    setTimeout(() => {
      setLoading(false);
    }, 500);
  };

  const handlePageChangeYouform = (page) => {
    setLoading(true);
    setActivePageYouform(page);
    setTimeout(() => {
      setLoading(false);
    }, 500);
  };

  const handlePageChangeSamcart = (page) => {
    setLoading(true);
    setActivePageSamcart(page);
    setTimeout(() => {
      setLoading(false);
    }, 500);
  };

  const handlePageChangeStealthseminar = (page) => {
    setLoading(true);
    setActivePageStealthseminar(page);
    setTimeout(() => {
      setLoading(false);
    }, 500);
  };

  const handlePageChangeShopify = (page) => {
    setLoading(true);
    setActivePageShopify(page);
    setTimeout(() => {
      setLoading(false);
    }, 500);
  };

  const handlePageChangeUltracart = (page) => {
    setLoading(true);
    setActivePageUltracart(page);
    setTimeout(() => {
      setLoading(false);
    }, 500);
  };

  const CommonPagination = ({ activePage, setPage, totalPages }) => {
    if (totalPages <= 1) return null;
    return (
      <Flex justify="center" align="center" mt={20}>
        <Pagination value={activePage} onChange={setPage} total={totalPages} />
      </Flex>
    );
  }

  useEffect(() => {
    document.documentElement.setAttribute('data-theme', colorTheme);
  }, [colorTheme]);

  return (
    <>
    	<VisiLoader VisiLoaderVisible={PaymentProcessingCartLoader} />
    	<VerifyWebhookModal
    	  opened={verifyModalOpen}
    	  onClose={() => {
    	    setVerifyModalOpen(false);
    	    if (verifyProcessor) {
    	      getWebhookListData(verifyProcessor);
    	    }
    	  }}
    	  webhookId={verifyWebhookId}
    	  processor={verifyProcessor}
    	  webhookUrl={verifyWebhookUrl}
    	  webhookName={verifyWebhookName}
    	/>
      {/* ═══════════ UPDATE DETECTED FIELDS MODAL ═══════════ */}
      <Modal
        opened={detectedFieldsModalOpen}
        onClose={() => { setDetectedFieldsModalOpen(false); setDetectedFieldsJson(''); setDetectedFields([]); }}
        title={<Text fw={600}>Update Detected Fields</Text>}
        size="lg"
      >
        <Text size="sm" color="dimmed" mb="sm">Paste a sample webhook JSON payload below to detect available fields for rule building.</Text>
        <Textarea
          placeholder='Edit the JSON below or paste your own webhook payload'
          minRows={8}
          autosize
          maxRows={15}
          value={detectedFieldsJson}
          onChange={(e) => setDetectedFieldsJson(e.currentTarget.value)}
          mb="sm"
        />
        <Button onClick={handleDetectFields} mb="md" size="sm">Detect Fields</Button>

        {detectedFields.length > 0 && (
          <>
            <Divider mb="sm" />
            <Text size="sm" fw={600} mb="xs">Detected Fields ({detectedFields.length}):</Text>
            <Box style={{ maxHeight: 250, overflowY: 'auto', border: '1px solid #e9ecef', borderRadius: 6, padding: 10 }} mb="md">
              {detectedFields.map((field, i) => (
                <Group key={i} spacing="xs" mb={4}>
                  <Text size="sm">• {dotToLabel(field)}</Text>
                  <Text size="xs" color="dimmed">({field})</Text>
                </Group>
              ))}
            </Box>
            <Button onClick={handleSaveDetectedFields} color="green" size="sm">Save Fields</Button>
          </>
        )}
      </Modal>

    	<div style={{ display: activePPC === "payment-processing-carts" ? "block" : "none"}}>
	      <Group position="apart" mb="xs">
	        <Text weight={500} fz={14}>PAYMENT PROCESSING AND CARTS <HelpTip helpId={265} /></Text>
	      </Group>
	      <div style={{display:"flex"}}>
	      	<Text fw={500} mr={5} fz={14}> Step 1: </Text>
	      	<Text fz={14}>Activate any payment processor or shopping cart you want to connect via web hook by clicking on the desired icon below.</Text>
	      </div>
	      <Text mb={15} fz={14}>Note: You will use either a single cart or a single processor in a campaign or test. There is no need to set up both a processor and a cart.</Text>
	      <div style={{display:"flex"}}>
	      	<Text fw={500} mr={5} fz={14}> Step 2: </Text>
	      	<Text fz={14}>Get the proper web hook link inside of Visiopt.</Text>
	      </div>
	      <Text mb={15} fz={14}>Note: This can be accomplished in either testing or campaigns. Once completed it will work for both testing and campaigns</Text>
	      <div style={{display:"flex"}}>
	      	<Text fw={500} mr={5} fz={14}> Step 3: </Text>
	      	<Text fz={14}>Place the web hook in your cart or processor.</Text>
	      </div>
	      <Text mb={15} fz={14}>Note : A new unique Webhook must be created for each test or campaign created.</Text>
	      <Text mb={15} fz={14}>When a campaign and test share the same funnel then the same Webhook may be used for both.</Text>
	      <div style={{display:"flex"}}>
		      <Text mb={30} mr={5} fz={14}>To learn how to get the proper webhook link in Visiopt, and how to connect it to various</Text>
		      <Anchor href="https://visiopt.com/help-videos/connect-carts.html" target="_blank" td="none" fw={700} fz={14}>
			      Carts and Payment Processors, visit our Cart and Payment Processor Connection Help Page.
		      </Anchor>
		    </div>
        <Text fw={500} mb={10}>Payment Processors:</Text>
        <Group spacing="xs" mb={25}>
        	{paymentProcessorData.map((item,index) => (
	  	      <div key={index} className={activePPCClass.includes(item.action_name) ? "email-thumb active-email" : "email-thumb"} onClick={() => handleAction(item.action_name)}>
	  	      	<div className="thumb-holder">
	  	      		<img src={item.img} alt="Payment Processor" />
	  	      	</div>
	  	      	<span className="email-thumb-text">{item.name}</span>
	  	      </div>
  	      ))}
        </Group>
        <Text fw={500} mb={10}>Shopping Carts:</Text>
        <Group spacing="xs" mb={15}>
        	{shoppingCartsData.map((item,index) => (
  	      	<div key={index} className={activePPCClass.includes(item.action_name) ? "email-thumb active-email" : "email-thumb"} onClick={() => handleAction(item.action_name)}>
	  	      	<div className="thumb-holder">
	  	      		<img src={item.img} alt="Shopping Carts" />
	  	      	</div>
	  	      	<span className="email-thumb-text">{item.name}</span>
	  	      </div>
  	      ))}
        </Group>
	    </div>
      <div ref={editFormRef} id="editFormTop">
      <div style={{ display: activeId === "autorize.net" ? "block" : "none"}}>
      	<form onSubmit={forms.authorize_net.onSubmit((formData) => { handleSaveWebhook(formData, "authorize", "webhook_capture_authorize_net", forms.authorize_net); })}>
		      <Group position="apart" mb="xs">
		        <Text weight={500}>GENERATE WEBHOOK AUTHORIZE <HelpTip helpId={265} /></Text>
		      </Group>
		      {activeId === "autorize.net" && createWebhookForm('authorize', 'authorizeMergeWebhook')}
	  	    <Group spacing="xs" mb={10}>
		  	    <Button type="submit" size="sm" mt={10}>Save & Genrate Webhook URL</Button>
		  	    <Button type="button" style={{backgroundColor: "red"}} size="sm" w={80} mt={10} onClick={() => handleAction('cancel')}>
		  	      Cancel
		  	    </Button>
	  	    </Group>
  	    </form>
  	    {activeId === "autorize.net" && webhookTableData(webhookUrlListData, "authorize", loading, activePageAuthorize)}
        {activeId === "autorize.net" && <CommonPagination activePage={activePageAuthorize} setPage={handlePageChangeAuthorize} totalPages={totalPagesAuthorize} />}
	    </div>
      <div style={{ display: activeId === "hubspot" ? "block" : "none"}}>
        <form onSubmit={forms.hubspot.onSubmit((formData) => { handleSaveWebhook(formData, "hubspot", "webhook_capture_hubspot", forms.hubspot); })}>
          <Group position="apart" mb="xs">
            <Text weight={500}>GENERATE WEBHOOK HUBSPOT <HelpTip helpId={265} /></Text>
          </Group>
          {activeId === "hubspot" && createWebhookForm('hubspot', 'hubspotMergeWebhook')}
          <Group spacing="xs" mb={10}>
            <Button type="submit" size="sm" mt={10}>Save & Genrate Webhook URL</Button>
            <Button type="button" style={{backgroundColor: "red"}} size="sm" w={80} mt={10} onClick={() => handleAction('cancel')}>
              Cancel
            </Button>
          </Group>
        </form>
        {activeId === "hubspot" && webhookTableData(webhookUrlListData, "hubspot", loading, activePageAuthorize)}
        {activeId === "hubspot" && <CommonPagination activePage={activePageHubSpot} setPage={handlePageChangeHubSpot} totalPages={totalPagesHubSpot} />}
      </div>
	    <div style={{ display: activeId === "chargebee" ? "block" : "none"}}>
      	<form onSubmit={forms.chargebee.onSubmit((formData) => { handleSaveWebhook(formData, "chargebee", "webhook_capture_chargebee", forms.chargebee); })}>
		      <Group position="apart" mb="xs">
		        <Text weight={500}>GENERATE WEBHOOK CHARGEBEE <HelpTip helpId={265} /></Text>
		      </Group>
	  	    {activeId === "chargebee" && createWebhookForm('chargebee','chargebeeMergeWebhook')}
	  	    <Group spacing="xs" mb={10}>
		  	    <Button type="submit" size="sm" mt={10}>Save & Genrate Webhook URL</Button>
		  	    <Button type="button" style={{backgroundColor: "red"}} size="sm" w={80} mt={10} onClick={() => handleAction('cancel')}>
		  	      Cancel
		  	    </Button>
	  	    </Group>
  	    </form>
  	    {activeId === "chargebee" && webhookTableData(webhookUrlListData, "chargebee", loading, activePageChargebee)}
        {activeId === "chargebee" && <CommonPagination activePage={activePageChargebee} setPage={handlePageChangeChargebee} totalPages={totalPagesChargebee} />}
	    </div>
	    <div style={{ display: activeId === "easypaydirect" ? "block" : "none"}}>
      	<form onSubmit={forms.easypaydirect.onSubmit((formData) => { handleSaveWebhook(formData, "easypaydirect", "webhook_capture_easypaydirect", forms.easypaydirect); })}>
		      <Group position="apart" mb="xs">
		        <Text weight={500}>GENERATE WEBHOOK EASYPAYDIRECT <HelpTip helpId={265} /></Text>
		      </Group>
		      {activeId === "easypaydirect" && createWebhookForm('easypaydirect','easypaydirectMergeWebhook')}
	  	    <Group spacing="xs" mb={10}>
		  	    <Button type="submit" size="sm" mt={10}>Save & Genrate Webhook URL</Button>
		  	    <Button type="button" style={{backgroundColor: "red"}} size="sm" w={80} mt={10} onClick={() => handleAction('cancel')}>
		  	      Cancel
		  	    </Button>
	  	    </Group>
  	    </form>
  	    {activeId === "easypaydirect" && webhookTableData(webhookUrlListData, "easypaydirect", loading, activePageEasypaydirect)}
        {activeId === "easypaydirect" && <CommonPagination activePage={activePageEasypaydirect} setPage={handlePageChangeEasypaydirect} totalPages={totalPagesEasypaydirect} />}
	    </div>
	    <div style={{ display: activeId === "hitpay" ? "block" : "none"}}>
      	<form onSubmit={forms.hitpay.onSubmit((formData) => { handleSaveWebhook(formData, "hitpay", "webhook_capture_hitpay", forms.hitpay); })}>
		      <Group position="apart" mb="xs">
		        <Text weight={500}>GENERATE WEBHOOK HITPAY <HelpTip helpId={265} /></Text>
		      </Group>
		      {activeId === "hitpay" && createWebhookForm('hitpay','hitpayMergeWebhook')}
	  	    <Group spacing="xs" mb={10}>
		  	    <Button type="submit" size="sm" mt={10}>Save & Genrate Webhook URL</Button>
		  	    <Button type="button" style={{backgroundColor: "red"}} size="sm" w={80} mt={10} onClick={() => handleAction('cancel')}>
		  	      Cancel
		  	    </Button>
	  	    </Group>
  	    </form>
  	    {activeId === "hitpay" && webhookTableData(webhookUrlListData, "hitpay", loading, activePageHitpay)}
        {activeId === "hitpay" && <CommonPagination activePage={activePageHitpay} setPage={handlePageChangeHitpay} totalPages={totalPagesHitpay} />}
	    </div>
	    <div style={{ display: activeId === "housecallpro" ? "block" : "none"}}>
      	<form onSubmit={forms.housecallpro.onSubmit((formData) => { handleSaveWebhook(formData, "housecallpro", "webhook_capture_housecallpro", forms.housecallpro); })}>
		      <Group position="apart" mb="xs">
		        <Text weight={500}>GENERATE WEBHOOK HOUSECALLPRO <HelpTip helpId={265} /></Text>
		      </Group>
		      {activeId === "housecallpro" && createWebhookForm('housecallpro','housecallproMergeWebhook')}
	  	    <Group spacing="xs" mb={10}>
		  	    <Button type="submit" size="sm" mt={10}>Save & Genrate Webhook URL</Button>
		  	    <Button type="button" style={{backgroundColor: "red"}} size="sm" w={80} mt={10} onClick={() => handleAction('cancel')}>
		  	      Cancel
		  	    </Button>
	  	    </Group>
  	    </form>
  	    {activeId === "housecallpro" && webhookTableData(webhookUrlListData, "housecallpro", loading, activePageHousecallpro)}
        {activeId === "housecallpro" && <CommonPagination activePage={activePageHousecallpro} setPage={handlePageChangeHousecallpro} totalPages={totalPagesHousecallpro} />}
	    </div>
	    <div style={{ display: activeId === "merchantx" ? "block" : "none"}}>
      	<form onSubmit={forms.merchantx.onSubmit((formData) => { handleSaveWebhook(formData, "merchantx", "webhook_capture_merchantx", forms.merchantx); })}>
		      <Group position="apart" mb="xs">
		        <Text weight={500}>GENERATE WEBHOOK MARCHANTX <HelpTip helpId={265} /></Text>
		      </Group>
		      {activeId === "merchantx" && createWebhookForm('merchantx','merchantxMergeWebhook')}
	  	    <Group spacing="xs" mb={10}>
		  	    <Button type="submit" size="sm" mt={10}>Save & Genrate Webhook URL</Button>
		  	    <Button type="button" style={{backgroundColor: "red"}} size="sm" w={80} mt={10} onClick={() => handleAction('cancel')}>
		  	      Cancel
		  	    </Button>
	  	    </Group>
  	    </form>
  	    {activeId === "merchantx" && webhookTableData(webhookUrlListData, "merchantx", loading, activePageMerchantx)}
        {activeId === "merchantx" && <CommonPagination activePage={activePageMerchantx} setPage={handlePageChangeMerchantx} totalPages={totalPagesMerchantx} />}
	    </div>
      <div style={{ display: activeId === "gocardless" ? "block" : "none"}}>
      	<form onSubmit={forms.gocardless.onSubmit((formData) => { handleSaveWebhook(formData, "gocardless", "webhook_capture_gocardless", forms.gocardless); })}>
		      <Group position="apart" mb="xs">
		        <Text weight={500}>GENERATE WEBHOOK GOCARDLESS <HelpTip helpId={265} /></Text>
		      </Group>
		      {activeId === "gocardless" && createWebhookForm('gocardless','gocardlessMergeWebhook')}
	  	    <Group spacing="xs" mb={10}>
		  	    <Button type="submit" size="sm" mt={10}>Save & Genrate Webhook URL</Button>
		  	    <Button type="button" style={{backgroundColor: "red"}} size="sm" w={80} mt={10} onClick={() => handleAction('cancel')}>
		  	      Cancel
		  	    </Button>
	  	    </Group>
	  	    {activeId === "gocardless" && webhookTableData(webhookUrlListData, "gocardless", loading, activePageGocardless)}
          {activeId === "gocardless" && <CommonPagination activePage={activePageGocardless} setPage={handlePageChangeGocardless} totalPages={totalPagesGocardless} />}
  	    </form>
	    </div>
	    <div style={{ display: activeId === "paypal_classic_ipn" ? "block" : "none"}}>
      	<form onSubmit={forms.paypal.onSubmit((formData) => { handleSaveWebhook(formData, "paypal", "webhook_capture_paypal", forms.paypal); })}>
		      <Group position="apart" mb="xs">
		        <Text weight={500}>GENERATE WEBHOOK PAYPAL <HelpTip helpId={265} /></Text>
		      </Group>
		      {activeId === "paypal_classic_ipn" && createWebhookForm('paypal','paypalMergeWebhook')}
	  	    <Group spacing="xs" mb={10}>
		  	    <Button type="submit" size="sm" mt={10}>Save & Genrate Webhook URL</Button>
		  	    <Button type="button" style={{backgroundColor: "red"}} size="sm" w={80} mt={10} onClick={() => handleAction('cancel')}>
		  	      Cancel
		  	    </Button>
	  	    </Group>
  	    </form>
  	    {activeId === "paypal_classic_ipn" && webhookTableData(webhookUrlListData, "paypal", loading, activePagePaypal)}
        {activeId === "paypal_classic_ipn" && <CommonPagination activePage={activePagePaypal} setPage={handlePageChangePaypal} totalPages={totalPagesPaypal} />}
	    </div>
	    <div style={{ display: activeId === "recurly" ? "block" : "none"}}>
      	<form onSubmit={forms.recurly.onSubmit((formData) => { handleSaveWebhook(formData, "recurly", "webhook_capture_recurly", forms.recurly); })}>
		      <Group position="apart" mb="xs">
		        <Text weight={500}>GENERATE WEBHOOK RECURLY <HelpTip helpId={265} /></Text>
		      </Group>
		      {activeId === "recurly" && createWebhookForm('recurly','recurlyMergeWebhook')}
	  	    <Group spacing="xs" mb={10}>
		  	    <Button type="submit" size="sm" mt={10}>Save & Genrate Webhook URL</Button>
		  	    <Button type="button" style={{backgroundColor: "red"}} size="sm" w={80} mt={10} onClick={() => handleAction('cancel')}>
		  	      Cancel
		  	    </Button>
	  	    </Group>
  	    </form>
  	    {activeId === "recurly" && webhookTableData(webhookUrlListData, "recurly", loading, activePageRecurly)}
        {activeId === "recurly" && <CommonPagination activePage={activePageRecurly} setPage={handlePageChangeRecurly} totalPages={totalPagesRecurly} />}
	    </div>
      <div style={{ display: activeId === "stripe" ? "block" : "none"}}>
      	<form onSubmit={forms.stripe.onSubmit((formData) => { handleSaveWebhook(formData, "stripe", "webhook_capture_stripe", forms.stripe); })}>
		      <Group position="apart" mb="xs">
		        <Text weight={500}>GENERATE WEBHOOK STRIPE <HelpTip helpId={265} /></Text>
		      </Group>
		      {activeId === "stripe" && createWebhookForm('stripe','stripeMergeWebhook')}
	  	    <Group spacing="xs" mb={10}>
		  	    <Button type="submit" size="sm" mt={10}>Save & Genrate Webhook URL</Button>
		  	    <Button type="button" style={{backgroundColor: "red"}} size="sm" w={80} mt={10} onClick={() => handleAction('cancel')}>
		  	      Cancel
		  	    </Button>
	  	    </Group>
  	    </form>
	      <Alert icon={<IconAlertTriangle size={16} />} color="blue" mt="sm" mb="sm">
	        <Text weight={700} mb="xs">Enter your Stripe Secret Key (optional) and VisiOpt will automatically create and configure the webhook in your Stripe account.</Text>
	        If you leave the Secret Key blank, no webhook is created automatically — you can create it manually in Stripe using the generated webhook URL shown below.{' '}
	        If you are using <b>Stripe Payment Links</b>, <b>Stripe Hosted Checkout</b>, or <b>Embedded Checkout</b>, please complete the additional setup described here:{' '}
	        <Anchor href={STRIPE_CHECKOUT_DOC_URL} target="_blank" rel="noopener noreferrer" fw={700}>View setup instructions</Anchor>. Otherwise, no additional setup is required.
	      </Alert>
  	    {activeId === "stripe" && webhookTableData(webhookUrlListData, "stripe", loading, activePageStripe)}
        {activeId === "stripe" && <CommonPagination activePage={activePageStripe} setPage={handlePageChangeStripe} totalPages={totalPagesStripe} />}
	    </div>
	    <div style={{ display: activeId === "buygoods" ? "block" : "none"}}>
      	<form onSubmit={forms.buygoods.onSubmit((formData) => { handleSaveWebhook(formData, "buygoods", "webhook_capture_buygoods", forms.buygoods); })}>
		      <Group position="apart" mb="xs">
		        <Text weight={500}>GENERATE WEBHOOK BUYGOODS <HelpTip helpId={265} /></Text>
		      </Group>
		      {activeId === "buygoods" && createWebhookForm('buygoods','buygoodsMergeWebhook')}
	  	    <Group spacing="xs" mb={10}>
		  	    <Button type="submit" size="sm" mt={10}>Save & Genrate Webhook URL</Button>
		  	    <Button type="button" style={{backgroundColor: "red"}} size="sm" w={80} mt={10} onClick={() => handleAction('cancel')}>
		  	      Cancel
		  	    </Button>
	  	    </Group>
  	    </form>
  	    {activeId === "buygoods" && webhookTableData(webhookUrlListData, "buygoods", loading, activePageBuygoods)}
        {activeId === "buygoods" && <CommonPagination activePage={activePageBuygoods} setPage={handlePageChangeBuygoods} totalPages={totalPagesBuygoods} />}
	    </div>
	    <div style={{ display: activeId === "calendly" ? "block" : "none"}}>
      	<form onSubmit={forms.calendly.onSubmit((formData) => { handleSaveWebhook(formData, "calendly", "webhook_capture_calendly", forms.calendly); })}>
		      <Group position="apart" mb="xs">
		        <Text weight={500}>GENERATE WEBHOOK CALENDLY <HelpTip helpId={265} /></Text>
		      </Group>
		      {activeId === "calendly" && createWebhookForm('calendly','calendlyMergeWebhook')}
	  	    <Group spacing="xs" mb={10}>
		  	    <Button type="submit" size="sm" mt={10}>Save & Genrate Webhook URL</Button>
		  	    <Button type="button" style={{backgroundColor: "red"}} size="sm" w={80} mt={10} onClick={() => handleAction('cancel')}>
		  	      Cancel
		  	    </Button>
	  	    </Group>
	  	  </form>
	  	  {activeId === "calendly" && webhookTableData(webhookUrlListData, "calendly", loading, activePageCalendly)}
        {activeId === "calendly" && <CommonPagination activePage={activePageCalendly} setPage={handlePageChangeCalendly} totalPages={totalPagesCalendly} />}
	    </div>
      <div style={{ display: activeId === "clickbank" ? "block" : "none"}}>
      	<form onSubmit={forms.clickbank.onSubmit((formData) => { handleSaveWebhook(formData, "clickbank", "webhook_capture_clickbank", forms.clickbank); })}>
		      <Group position="apart" mb="xs">
		        <Text weight={500}>GENERATE WEBHOOK CLICKBANK <HelpTip helpId={265} /></Text>
		      </Group>
		      {activeId === "clickbank" && createWebhookForm('clickbank','clickbankMergeWebhook')}
	  	    <Group spacing="xs" mb={10}>
		  	    <Button type="submit" size="sm" mt={10}>Save & Genrate Webhook URL</Button>
		  	    <Button type="button" style={{backgroundColor: "red"}} size="sm" w={80} mt={10} onClick={() => handleAction('cancel')}>
		  	      Cancel
		  	    </Button>
	  	    </Group>
	  	  </form>
	  	  {activeId === "clickbank" && webhookTableData(webhookUrlListData, "clickbank", loading, activePageClickbank)}
        {activeId === "clickbank" && <CommonPagination activePage={activePageClickbank} setPage={handlePageChangeClickbank} totalPages={totalPagesClickbank} />}
	    </div>
	    <div style={{ display: activeId === "clickfunnels" ? "block" : "none"}}>
      	<form onSubmit={forms.clickfunnels.onSubmit((formData) => { handleSaveWebhook(formData, "clickfunnels", "webhook_capture_clickfunnel", forms.clickfunnels); })}>
		      <Group position="apart" mb="xs">
		        <Text weight={500}>GENERATE WEBHOOK CLICKFUNNELS <HelpTip helpId={265} /></Text>
		      </Group>
		      {activeId === "clickfunnels" && createWebhookForm('clickfunnels','clickfunnelsMergeWebhook')}
	  	    <Group spacing="xs" mb={10}>
		  	    <Button type="submit" size="sm" mt={10}>Save & Genrate Webhook URL</Button>
		  	    <Button type="button" style={{backgroundColor: "red"}} size="sm" w={80} mt={10} onClick={() => handleAction('cancel')}>
		  	      Cancel
		  	    </Button>
	  	    </Group>
  	    </form>
  	    {activeId === "clickfunnels" && webhookTableData(webhookUrlListData, "clickfunnels", loading, activePageClickfunnels)}
        {activeId === "clickfunnels" && <CommonPagination activePage={activePageClickfunnels} setPage={handlePageChangeClickfunnels} totalPages={totalPagesClickfunnels} />}
	    </div>
	    <div style={{ display: activeId === "digistore24" ? "block" : "none"}}>
      	<form onSubmit={forms.digistore24.onSubmit((formData) => { handleSaveWebhook(formData, "digistore24", "webhook_capture_digistore24", forms.digistore24); })}>
		      <Group position="apart" mb="xs">
		        <Text weight={500}>GENERATE WEBHOOK DIGISTORE24 <HelpTip helpId={265} /></Text>
		      </Group>
		      {activeId === "digistore24" && createWebhookForm('digistore24','digistore24MergeWebhook')}
	  	    <Group spacing="xs" mb={10}>
		  	    <Button type="submit" size="sm" mt={10}>Save & Genrate Webhook URL</Button>
		  	    <Button type="button" style={{backgroundColor: "red"}} size="sm" w={80} mt={10} onClick={() => handleAction('cancel')}>
		  	      Cancel
		  	    </Button>
	  	    </Group>
  	    </form>
  	    {activeId === "digistore24" && webhookTableData(webhookUrlListData, "digistore24", loading, activePageDigistore24)}
        {activeId === "digistore24" && <CommonPagination activePage={activePageDigistore24} setPage={handlePageChangeDigistore24} totalPages={totalPagesDigistore24} />}
	    </div>
	    <div style={{ display: activeId === "gohighlevel" ? "block" : "none"}}>
      	<form onSubmit={forms.gohighlevel.onSubmit((formData) => { handleSaveWebhook(formData, "gohighlevel", "webhook_capture_gohighlevel", forms.gohighlevel); })}>
		      <Group position="apart" mb="xs">
		        <Text weight={500}>GENERATE WEBHOOK GOHIGHLEVEL <HelpTip helpId={265} /></Text>
		      </Group>
		      {activeId === "gohighlevel" && createWebhookForm('gohighlevel','gohighlevelMergeWebhook')}
	  	    <Group spacing="xs" mb={10}>
		  	    <Button type="submit" size="sm" mt={10}>Save & Genrate Webhook URL</Button>
		  	    <Button type="button" style={{backgroundColor: "red"}} size="sm" w={80} mt={10} onClick={() => handleAction('cancel')}>
		  	      Cancel
		  	    </Button>
	  	    </Group>
  	    </form>
  	    {activeId === "gohighlevel" && webhookTableData(webhookUrlListData, "gohighlevel", loading, activePageGohighlevel)}
        {activeId === "gohighlevel" && <CommonPagination activePage={activePageGohighlevel} setPage={handlePageChangeGohighlevel} totalPages={totalPagesGohighlevel} />}
	    </div>
      <div style={{ display: activeId === "kajabi" ? "block" : "none"}}>
      	<form onSubmit={forms.kajabi.onSubmit((formData) => { handleSaveWebhook(formData, "kajabi", "webhook_capture_kajabi", forms.kajabi); })}>
		      <Group position="apart" mb="xs">
		        <Text weight={500}>GENERATE WEBHOOK KAJABI <HelpTip helpId={265} /></Text>
		      </Group>
          {activeId === "kajabi" && createWebhookForm('kajabi','kajabiMergeWebhook')}
          <Group spacing="xs" mb={10}>
            <Button type="submit" size="sm" mt={10}>Save & Genrate Webhook URL</Button>
            <Button type="button" style={{backgroundColor: "red"}} size="sm" w={80} mt={10} onClick={() => handleAction('cancel')}>
              Cancel
            </Button>
          </Group>
	  	  </form>
        {activeId === "kajabi" && webhookTableData(webhookUrlListData, "kajabi", loading, activePageKajabi)}
        {activeId === "kajabi" && <CommonPagination activePage={activePageKajabi} setPage={handlePageChangeKajabi} totalPages={totalPageskajabi} />}
	    </div>
	    <div style={{ display: activeId === "katra" ? "block" : "none"}}>
      	<form onSubmit={forms.katra.onSubmit((formData) => { handleSaveWebhook(formData, "katra", "webhook_capture_katra", forms.katra); })}>
		      <Group position="apart" mb="xs">
		        <Text weight={500}>GENERATE WEBHOOK KATRA <HelpTip helpId={265} /></Text>
		      </Group>
		      {activeId === "katra" && createWebhookForm('katra','katraMergeWebhook')}
	  	    <Group spacing="xs" mb={10}>
		  	    <Button type="submit" size="sm" mt={10}>Save & Genrate Webhook URL</Button>
		  	    <Button type="button" style={{backgroundColor: "red"}} size="sm" w={80} mt={10} onClick={() => handleAction('cancel')}>
		  	      Cancel
		  	    </Button>
	  	    </Group>
  	    </form>
  	    {activeId === "katra" && webhookTableData(webhookUrlListData, "katra", loading, activePageKartra)}
        {activeId === "katra" && <CommonPagination activePage={activePageKartra} setPage={handlePageChangeKartra} totalPages={totalPagesKartra} />}
	    </div>
	    <div style={{ display: activeId === "konnektive" ? "block" : "none"}}>
      	<form onSubmit={forms.konnektive.onSubmit((formData) => { handleSaveWebhook(formData, "konnektive", "webhook_capture_konnektive", forms.konnektive); })}>
		      <Group position="apart" mb="xs">
		        <Text weight={500}>GENERATE WEBHOOK KONNEKTIVE <HelpTip helpId={265} /></Text>
		      </Group>
		      {activeId === "konnektive" && createWebhookForm('konnektive','konnektiveMergeWebhook')}
	  	    <Group spacing="xs" mb={10}>
		  	    <Button type="submit" size="sm" mt={10}>Save & Genrate Webhook URL</Button>
		  	    <Button type="button" style={{backgroundColor: "red"}} size="sm" w={80} mt={10} onClick={() => handleAction('cancel')}>
		  	      Cancel
		  	    </Button>
	  	    </Group>
  	    </form>
  	    {activeId === "konnektive" && webhookTableData(webhookUrlListData, "konnektive", loading, activePageKonnektive)}
        {activeId === "konnektive" && <CommonPagination activePage={activePageKonnektive} setPage={handlePageChangeKonnektive} totalPages={totalPagesKonnektive} />}
	    </div>
	    <div style={{ display: activeId === "ontraport" ? "block" : "none"}}>
      	<form onSubmit={forms.ontraport.onSubmit((formData) => { handleSaveWebhook(formData, "ontraport", "webhook_capture_ontraport", forms.ontraport); })}>
		      <Group position="apart" mb="xs">
		        <Text weight={500}>GENERATE WEBHOOK ONTRAPORT <HelpTip helpId={265} /></Text>
		      </Group>
		      {activeId === "ontraport" && createWebhookForm('ontraport','ontraportMergeWebhook')}
	  	    <Group spacing="xs" mb={10}>
		  	    <Button type="submit" size="sm" mt={10}>Save & Genrate Webhook URL</Button>
		  	    <Button type="button" style={{backgroundColor: "red"}} size="sm" w={80} mt={10} onClick={() => handleAction('cancel')}>
		  	      Cancel
		  	    </Button>
	  	    </Group>
  	    </form>
  	    {activeId === "ontraport" && webhookTableData(webhookUrlListData, "ontraport", loading, activePageOntraport)}
        {activeId === "ontraport" && <CommonPagination activePage={activePageOntraport} setPage={handlePageChangeOntraport} totalPages={totalPagesOntraport} />}
	    </div>
	    <div style={{ display: activeId === "paykickstartes" ? "block" : "none"}}>
      	<form onSubmit={forms.paykickstartes.onSubmit((formData) => { handleSaveWebhook(formData, "paykickstartes", "webhook_capture_paykickstart", forms.paykickstartes); })}>
		      <Group position="apart" mb="xs">
		        <Text weight={500}>GENERATE WEBHOOK PAYKICKSTARTES <HelpTip helpId={265} /></Text>
		      </Group>
		      {activeId === "paykickstartes" && createWebhookForm('paykickstartes','paykickstartMergeWebhook')}
	  	    <Group spacing="xs" mb={10}>
		  	    <Button type="submit" size="sm" mt={10}>Save & Genrate Webhook URL</Button>
		  	    <Button type="button" style={{backgroundColor: "red"}} size="sm" w={80} mt={10} onClick={() => handleAction('cancel')}>
		  	      Cancel
		  	    </Button>
	  	    </Group>
  	    </form>
  	    {activeId === "paykickstartes" && webhookTableData(webhookUrlListData, "paykickstartes", loading, activePagePaykickstart)}
        {activeId === "paykickstartes" && <CommonPagination activePage={activePagePaykickstart} setPage={handlePageChangePaykickstart} totalPages={totalPagesPaykickstart} />}
	    </div>
	    <div style={{ display: activeId === "samcart" ? "block" : "none"}}>
      	<form onSubmit={forms.samcart.onSubmit((formData) => { handleSaveWebhook(formData, "samcart", "webhook_capture_samcart", forms.samcart); })}>
		      <Group position="apart" mb="xs">
		        <Text weight={500}>GENERATE WEBHOOK SAM CART <HelpTip helpId={265} /></Text>
		      </Group>
		      {activeId === "samcart" && createWebhookForm('samcart','samcartMergeWebhook')}
	  	    <Group spacing="xs" mb={10}>
		  	    <Button type="submit" size="sm" mt={10}>Save & Genrate Webhook URL</Button>
		  	    <Button type="button" style={{backgroundColor: "red"}} size="sm" w={80} mt={10} onClick={() => handleAction('cancel')}>
		  	      Cancel
		  	    </Button>
	  	    </Group>
  	    </form>
  	    {activeId === "samcart" && webhookTableData(webhookUrlListData, "samcart", loading, activePageSamcart)}
        {activeId === "samcart" && <CommonPagination activePage={activePageSamcart} setPage={handlePageChangeSamcart} totalPages={totalPagesSamcart} />}
      </div>
	    <div style={{ display: activeId === "shopify" ? "block" : "none"}}>
      	<form onSubmit={forms.shopify.onSubmit((formData) => { handleSaveWebhook(formData, "shopify", "webhook_capture_shopify", forms.shopify); })}>
		      <Group position="apart" mb="xs">
		        <Text weight={500}>GENERATE WEBHOOK SHOPIFY <HelpTip helpId={265} /></Text>
		      </Group>
		      {activeId === "shopify" && createWebhookForm('shopify','shopifyMergeWebhook')}
	  	    <Group spacing="xs" mb={10}>
		  	    <Button type="submit" size="sm" mt={10}>Save & Genrate Webhook URL</Button>
		  	    <Button type="button" style={{backgroundColor: "red"}} size="sm" w={80} mt={10} onClick={() => handleAction('cancel')}>
		  	      Cancel
		  	    </Button>
	  	    </Group>
  	    </form>
  	    {activeId === "shopify" && webhookTableData(webhookUrlListData, "shopify", loading, activePageShopify)}
        {activeId === "shopify" && <CommonPagination activePage={activePageShopify} setPage={handlePageChangeShopify} totalPages={totalPagesShopify} />}
	    </div>
      <div style={{ display: activeId === "stealthseminar" ? "block" : "none"}}>
        <form onSubmit={forms.stealthseminar.onSubmit((formData) => { handleSaveWebhook(formData, "stealthseminar", "webhook_capture_stealthseminar", forms.stealthseminar); })}>
          <Group position="apart" mb="xs">
            <Text weight={500}>GENERATE WEBHOOK STEALTH SEMINAR <HelpTip helpId={265} /></Text>
          </Group>
          {activeId === "stealthseminar" && createWebhookForm('stealthseminar','stealthseminarMergeWebhook')}
          <Group spacing="xs" mb={10}>
            <Button type="submit" size="sm" mt={10}>Save & Genrate Webhook URL</Button>
            <Button type="button" style={{backgroundColor: "red"}} size="sm" w={80} mt={10} onClick={() => handleAction('cancel')}>
              Cancel
            </Button>
          </Group>
        </form>
        {activeId === "stealthseminar" && webhookTableData(webhookUrlListData, "stealthseminar", loading, activePageStealthseminar)}
        {activeId === "stealthseminar" && <CommonPagination activePage={activePageStealthseminar} setPage={handlePageChangeStealthseminar} totalPages={totalPagesStealthseminar} />}
      </div>
	    <div style={{ display: activeId === "ultracart" ? "block" : "none"}}>
      	<form onSubmit={forms.ultracart.onSubmit((formData) => { handleSaveWebhook(formData, "ultracart", "webhook_capture_ultracart", forms.ultracart); })}>
		      <Group position="apart" mb="xs">
		        <Text weight={500}>GENERATE WEBHOOK ULTRACART <HelpTip helpId={265} /></Text>
		      </Group>
		      {activeId === "ultracart" && createWebhookForm('ultracart','ultracartMergeWebhook')}
	  	    <Group spacing="xs" mb={10}>
		  	    <Button type="submit" size="sm" mt={10}>Save & Genrate Webhook URL</Button>
		  	    <Button type="button" style={{backgroundColor: "red"}} size="sm" w={80} mt={10} onClick={() => handleAction('cancel')}>
		  	      Cancel
		  	    </Button>
	  	    </Group>
  	    </form>
  	    {activeId === "ultracart" && webhookTableData(webhookUrlListData, "ultracart", loading, activePageUltracart)}
        {activeId === "ultracart" && <CommonPagination activePage={activePageUltracart} setPage={handlePageChangeUltracart} totalPages={totalPagesUltracart} />}
	    </div>
	    <div style={{ display: activeId === "thrivecart" ? "block" : "none"}}>
      	<form onSubmit={forms.thrivecart.onSubmit((formData) => { handleSaveWebhook(formData, "thrivecart", "webhook_capture_thrive_cart", forms.thrivecart); })}>
		      <Group position="apart" mb="xs">
		        <Text weight={500}>GENERATE WEBHOOK THRIVE CART <HelpTip helpId={265} /></Text>
		      </Group>
		      {activeId === "thrivecart" && createWebhookForm('thrivecart','thrivecartMergeWebhook')}
	  	    <Group spacing="xs" mb={10}>
		  	    <Button type="submit" size="sm" mt={10}>Save & Genrate Webhook URL</Button>
		  	    <Button type="button" style={{backgroundColor: "red"}} size="sm" w={80} mt={10} onClick={() => handleAction('cancel')}>
		  	      Cancel
		  	    </Button>
	  	    </Group>
  	    </form>
  	    {activeId === "thrivecart" && webhookTableData(webhookUrlListData, "thrivecart", loading, activePageThriveCart)}
        {activeId === "thrivecart" && <CommonPagination activePage={activePageThriveCart} setPage={handlePageChangeThriveCart} totalPages={totalPagesThriveCart} />}
	    </div>
	    <div style={{ display: activeId === "woocommerce" ? "block" : "none"}}>
      	<form onSubmit={forms.woocommerce.onSubmit((formData) => { handleSaveWebhook(formData, "woocommerce", "webhook_capture_woocommerce", forms.woocommerce); })}>
		      <Group position="apart" mb="xs">
		        <Text weight={500}>GENERATE WEBHOOK WOOCOMMERCE <HelpTip helpId={265} /></Text>
		      </Group>
		      {activeId === "woocommerce" && createWebhookForm('woocommerce','woocommerceMergeWebhook')}
	  	    <Group spacing="xs" mb={10}>
		  	    <Button type="submit" size="sm" mt={10}>Save & Genrate Webhook URL</Button>
		  	    <Button type="button" style={{backgroundColor: "red"}} size="sm" w={80} mt={10} onClick={() => handleAction('cancel')}>
		  	      Cancel
		  	    </Button>
	  	    </Group>
  	    </form>
  	    {activeId === "woocommerce" && webhookTableData(webhookUrlListData, "woocommerce", loading, activePageWoocommerce)}
        {activeId === "woocommerce" && <CommonPagination activePage={activePageWoocommerce} setPage={handlePageChangeWoocommerce} totalPages={totalPagesWoocommerce} />}
	    </div>
      <div style={{ display: activeId === "custom" ? "block" : "none"}}>
      	<form onSubmit={forms.custom.onSubmit((formData) => { handleSaveWebhook(formData, "custom", "webhook_capture_custom", forms.custom); })}>
		      <Group position="apart" mb="xs">
		        <Text weight={500}>Generate Webhook Custom <HelpTip helpId={265} /></Text>
		      </Group>
		      {activeId === "custom" && createWebhookForm('custom','customMergeWebhook')}
	  	    <Group spacing="xs" mb={10}>
		  	    <Button type="submit" size="sm" mt={10}>Save & generate Webhook url</Button>
		  	    <Button type="button" style={{backgroundColor: "red"}} size="sm" w={80} mt={10} onClick={() => handleAction('cancel')}>
		  	      Cancel
		  	    </Button>
	  	    </Group>
		    </form>
	      {activeId === "custom" && webhookTableData(webhookUrlListData, "custom", loading, activePageCustomCart)}
        {activeId === "custom" && <CommonPagination activePage={activePageCustomCart} setPage={handlePageChangeCustomCart} totalPages={totalPagesCustomCart} />}
  	    <Text size="sm" fz={16} fw={500} mb={10} mt={30}>To use a custom shopping cart, you needs pass data in JSON format using POST method :</Text>
  	    <Text mb={10}>{customJSONText}</Text>
  	    <Text size="sm" fz={16} fw={500} mb={10} c="red">If there is a refund, "refunded" has to be passed in the transaction type. And in refund, the same transaction id of the transaction from which the payment was made has to be passed.</Text>
  	    <Grid>
		      <Grid.Col span={6}>
		      	<Table withBorder withColumnBorders>
		      		<thead>
		      			<tr>
						      <th>Field</th>
						      <th>Field Description</th>
						    </tr>
		      		</thead>
		      		<tbody>
		      			<tr>
						      <td>transaction_id</td>
						      <td>Required</td>
						    </tr>
						    <tr>
						      <td>sales_amount</td>
						      <td>Required</td>
						    </tr>
						    <tr>
						      <td>email</td>
						      <td>Required</td>
						    </tr>
						    <tr>
						      <td>transaction_type</td>
						      <td>Optional</td>
						    </tr>
						    <tr>
						      <td>first_name</td>
						      <td>Optional</td>
						    </tr>
						    <tr>
						      <td>last_name</td>
						      <td>Optional</td>
						    </tr>
						    <tr>
						      <td>zipcode</td>
						      <td>Optional</td>
						    </tr>
						    <tr>
						      <td>country</td>
						      <td>Optional</td>
						    </tr>
						    <tr>
						      <td>state</td>
						      <td>Optional</td>
						    </tr>
						    <tr>
						      <td>city</td>
						      <td>Optional</td>
						    </tr>
						    <tr>
						      <td>_kx_vt</td>
						      <td>Optional</td>
						    </tr>
						    <tr>
						      <td>_kx_sid</td>
						      <td>Optional</td>
						    </tr>
						    <tr>
						      <td>_n_sid_random</td>
						      <td>Optional</td>
						    </tr>
						    <tr>
						      <td>ip_address</td>
						      <td>Optional</td>
						    </tr>
                <tr>
                  <td>phone</td>
                  <td>Optional</td>
                </tr>
		      		</tbody>
				    </Table>
		      </Grid.Col>
		      <Grid.Col span={6}>
		      	<Text size="sm" fz={16} fw={500} mb={10}>Sample javascript code to get value of _kx_vt,_kx_sid,_n_sid_random from your LP page, you can add this code to LP Page to get the values and save it at your side and then can send in webhook body.</Text>
		      	<Textarea
				    	value={customSampleJSCode}
				    	mt={10}
				    	variant="filled"
				    	minRows={23}
				 		/>
				 		<CopyButton  timeout={1000} value={customSampleJSCode}>
				      {({ copied, copy }) => (
				      	<div style={{ display: 'flex', justifyContent: 'flex-end' }}>
        					<Button color={copied ? 'teal' : 'blue'} onClick={copy} mt={5} size="xs">
				          	{copied ? 'Copied' : 'Copy'}
				        	</Button>
      					</div>
				      )}
				    </CopyButton>
		      </Grid.Col>
		    </Grid>
	    </div>
      <div style={{ display: activeId === "typeform" ? "block" : "none"}}>
        <form onSubmit={forms.typeform.onSubmit((formData) => { handleSaveWebhook(formData, "typeform", "webhook_capture_typeform", forms.typeform); })}>
          <Group position="apart" mb="xs">
            <Text weight={500}>GENERATE WEBHOOK TYPEFORM <HelpTip helpId={317} /></Text>
          </Group>
          {activeId === "typeform" && createWebhookForm('typeform', 'typeformMergeWebhook')}
          <Group spacing="xs" mb={10}>
            <Button type="submit" size="sm" mt={10}>Save & Genrate Webhook URL</Button>
            <Button type="button" style={{backgroundColor: "red"}} size="sm" w={80} mt={10} onClick={() => handleAction('cancel')}>
              Cancel
            </Button>
          </Group>
        </form>
        {activeId === "typeform" && webhookTableData(webhookUrlListData, "typeform", loading, activePageTypeform)}
        {activeId === "typeform" && <CommonPagination activePage={activePageTypeform} setPage={handlePageChangeTypeform} totalPages={totalPagesTypeform} />}
      </div>
      <div style={{ display: activeId === "youform" ? "block" : "none"}}>
        <form onSubmit={forms.youform.onSubmit((formData) => { handleSaveWebhook(formData, "youform", "webhook_capture_youform", forms.youform); })}>
          <Group position="apart" mb="xs">
            <Text weight={500}>GENERATE WEBHOOK YOUFORM <HelpTip helpId={265} /></Text>
          </Group>
          {activeId === "youform" && createWebhookForm('youform', 'youformMergeWebhook')}
          <Group spacing="xs" mb={10}>
            <Button type="submit" size="sm" mt={10}>Save & Genrate Webhook URL</Button>
            <Button type="button" style={{backgroundColor: "red"}} size="sm" w={80} mt={10} onClick={() => handleAction('cancel')}>
              Cancel
            </Button>
          </Group>
        </form>
        {activeId === "youform" && webhookTableData(webhookUrlListData, "youform", loading, activePageYouform)}
        {activeId === "youform" && <CommonPagination activePage={activePageYouform} setPage={handlePageChangeYouform} totalPages={totalPagesYouform} />}
      </div>
      </div>
    </>
  );
}